(function(){
const D2R=Math.PI/180, R2D=180/Math.PI;
const TIME=2.4, KN=0.5144*TIME;
const MARK={x:0,z:-280};
const LEE={x:0,z:-30};   // bouée sous le vent
const LINE={x1:-105,x2:105,z:0};
const RACES=4, LEVEL=[0.96,1.0,1.04,1.08];
const SHOP_PHONE='02 59 16 35 80';
const LOGO_SRC=window.NBZ_LOGO||'';
const LOGO=new Image(); LOGO.src=LOGO_SRC;
const CLASSES={
dinghy:{name:'Dériveur',min:36,k:0.55,pts:[[36,0.15],[42,0.68],[52,0.82],[90,0.97],[110,1],[135,0.95],[160,0.82],[180,0.74]],
ideal:t=>(t-35)/135,turnB:30,turnV:5,rudLoss:0.12,minD:3.6,cam:[17,6.8],fp:[0,2.1,3.6],boomMax:82,heelMax:0.42,startH:45},
cat:{name:'Catamaran',min:40,k:0.8,pts:[[40,0.15],[45,0.6],[55,0.8],[90,1],[110,1.06],[130,1],[150,0.74],[180,0.45]],
ideal:t=>(t-40)/150,turnB:18,turnV:3,rudLoss:0.22,minD:6.5,cam:[23,9],fp:[0,2.4,4.6],boomMax:60,heelMax:0.24,startH:50}
};
const RIVALS=[
{name:'Houat',col:0xe85d75,css:'#e85d75',skill:0.93,x:-70},
{name:'Hœdic',col:0x4fa3e0,css:'#4fa3e0',skill:0.9,x:-38},
{name:'Berder',col:0xf2c14e,css:'#f2c14e',skill:0.95,x:30},
{name:'Gavrinis',col:0x7bc47f,css:'#7bc47f',skill:0.87,x:58},
{name:'Arz',col:0xb388eb,css:'#b388eb',skill:0.91,x:86}
];
const $=id=>document.getElementById(id);
const canvas=$('c');
const renderer=new THREE.WebGLRenderer({canvas,antialias:true});
renderer.setPixelRatio(Math.min(devicePixelRatio,2));
const scene=new THREE.Scene();
const HORIZON=new THREE.Color('#d3e9ef'), ZENITH=new THREE.Color('#3b86c8');
scene.background=HORIZON; scene.fog=new THREE.Fog(HORIZON,170,520);
const camera=new THREE.PerspectiveCamera(60,1,0.1,4000);
const SUNDIR=new THREE.Vector3(-0.5,0.62,0.6).normalize();
scene.add(new THREE.HemisphereLight(0xeaf6ff,0x2a5a6e,0.55));
const sun=new THREE.DirectionalLight(0xfff1d6,0.95); sun.position.copy(SUNDIR).multiplyScalar(200); scene.add(sun);
const gradMap=(()=>{const t=new THREE.DataTexture(new Uint8Array([95,95,95,175,175,175,255,255,255]),3,1,THREE.RGBFormat);
t.minFilter=t.magFilter=THREE.NearestFilter;t.generateMipmaps=false;t.needsUpdate=true;return t;})();
const toon=(color,o)=>new THREE.MeshToonMaterial(Object.assign({color,gradientMap:gradMap},o||{}));
const INK=new THREE.Color('#0d1b2a'), outMats={};
function outlineMat(t){return outMats[t]||(outMats[t]=new THREE.ShaderMaterial({uniforms:{t:{value:t},c:{value:INK}},side:THREE.BackSide,
vertexShader:'uniform float t;void main(){gl_Position=projectionMatrix*modelViewMatrix*vec4(position+normal*t,1.0);}',
fragmentShader:'uniform vec3 c;void main(){gl_FragColor=vec4(c,1.0);}'}));}
function smoothNormals(geo){
const g=geo.clone(); g.computeVertexNormals();
const p=g.attributes.position, on=g.attributes.normal, n=new Float32Array(p.count*3), map=new Map();
const key=i=>Math.round(p.getX(i)*500)+'_'+Math.round(p.getY(i)*500)+'_'+Math.round(p.getZ(i)*500);
for(let i=0;i<p.count;i++){const k=key(i);let a=map.get(k);if(!a){a=[0,0,0];map.set(k,a);}a[0]+=on.getX(i);a[1]+=on.getY(i);a[2]+=on.getZ(i);}
for(let i=0;i<p.count;i++){const a=map.get(key(i)),l=Math.hypot(a[0],a[1],a[2])||1;n[i*3]=a[0]/l;n[i*3+1]=a[1]/l;n[i*3+2]=a[2]/l;}
g.setAttribute('normal',new THREE.BufferAttribute(n,3)); return g;
}
function ink(mesh,t){mesh.add(new THREE.Mesh(smoothNormals(mesh.geometry),outlineMat(t||0.035)));return mesh;}
const sky=new THREE.Mesh(new THREE.SphereGeometry(1800,32,16),new THREE.ShaderMaterial({side:THREE.BackSide,depthWrite:false,fog:false,
uniforms:{h:{value:HORIZON},z:{value:ZENITH},s:{value:SUNDIR}},
vertexShader:'varying vec3 vd;void main(){vd=normalize(position);gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0);}',
fragmentShader:`uniform vec3 h,z,s;varying vec3 vd;void main(){float y=max(vd.y,0.0);
float band=y<0.05?0.0:y<0.16?0.35:y<0.34?0.68:1.0;
vec3 c=mix(h,z,band);
float sd=dot(vd,s); c=mix(c,vec3(1.0,0.98,0.88),step(0.9988,sd)); c=mix(c,vec3(1.0,0.96,0.82),step(0.995,sd)*0.3);
gl_FragColor=vec4(c,1.0);}`}));
scene.add(sky);
const clouds=new THREE.Group(); scene.add(clouds);
(function(){const mat=toon(0xffffff,{fog:false}),shade=toon(0xdfe9f2,{fog:false});
for(let i=0;i<16;i++){const c=new THREE.Group(),a=i/16*Math.PI*2+Math.sin(i*7.3)*0.2,r=1150+((i*137)%300);
for(let j=0;j<5;j++){const k=38+((i*31+j*17)%40),s=new THREE.Mesh(new THREE.SphereGeometry(1,14,10),j===0?shade:mat);
s.scale.set(k*1.5,k*0.62,k);s.position.set((j-2)*58,(j%2)*14,((i+j)%3)*18);c.add(s);}
c.position.set(Math.cos(a)*r,170+((i*53)%170),Math.sin(a)*r);c.lookAt(0,c.position.y,0);clouds.add(c);}})();
function waveY(x,z,t){return 0.42*Math.sin(0.085*x+0.06*z+0.9*t)+0.25*Math.sin(0.16*z-0.11*x-1.2*t)+0.12*Math.sin(0.31*x+0.22*z+1.9*t)+0.06*Math.sin(0.6*(x-z)+2.7*t);}
const WGLSL=`uniform float uT,uAmp;
float wv(vec2 p){float t=uT;return uAmp*(0.42*sin(0.085*p.x+0.06*p.y+0.9*t)+0.25*sin(0.16*p.y-0.11*p.x-1.2*t)+0.12*sin(0.31*p.x+0.22*p.y+1.9*t)+0.06*sin(0.6*(p.x-p.y)+2.7*t));}
float gst(vec2 p){float zz=p.y-uT*6.0;return 0.6*sin(p.x*0.013+0.7)*sin(zz*0.017+1.3)+0.4*sin(p.x*0.031-zz*0.011+2.0);}
`;
function waterMat(amp){return new THREE.ShaderMaterial({
uniforms:{uT:{value:0},uAmp:{value:amp},uSun:{value:SUNDIR},uFog:{value:HORIZON},uNear:{value:170},uFar:{value:520}},
vertexShader:WGLSL+`varying vec3 vW;varying vec3 vN;varying float vH;
void main(){vec4 w=modelMatrix*vec4(position,1.0);float h=wv(w.xz);w.y+=h;float e=0.6;
vN=normalize(vec3(wv(w.xz-vec2(e,0.0))-wv(w.xz+vec2(e,0.0)),2.0*e,wv(w.xz-vec2(0.0,e))-wv(w.xz+vec2(0.0,e))));
vH=h;vW=w.xyz;gl_Position=projectionMatrix*viewMatrix*w;}`,
fragmentShader:WGLSL+`uniform vec3 uSun,uFog;uniform float uNear,uFar;varying vec3 vW;varying vec3 vN;varying float vH;
void main(){
vec3 N=normalize(vN);
vec3 deep=vec3(0.035,0.23,0.37),mid=vec3(0.06,0.36,0.51),hi=vec3(0.22,0.6,0.71);
float sh=(dot(N,uSun)-uSun.y)*6.0+vH*0.9;
vec3 col=sh>0.5?hi:sh>-0.35?mid:deep;
float g=gst(vW.xz);
col=mix(col,col*vec3(0.62,0.72,0.86),step(0.3,g));
col=mix(col,col*1.12+0.03,step(g,-0.45));
float cz=(vW.z+140.0)/60.0;float s=1.1*exp(-cz*cz);
float streak=step(0.94,sin(vW.x*0.33-uT*3.2*s+sin(vW.z*0.21)*1.6))*step(0.3,s);
col=mix(col,hi+0.14,streak*0.55);
float fm=step(0.6+0.1*sin(vW.x*0.9+vW.z*0.7),vH);
col=mix(col,vec3(0.93,0.97,0.98),fm*0.85);
vec3 V=normalize(cameraPosition-vW);vec3 R=reflect(-uSun,N);
col=mix(col,vec3(1.0),step(0.993,dot(R,V))*0.9);
col=mix(col,uFog,smoothstep(uNear,uFar,length(cameraPosition-vW)));
gl_FragColor=vec4(col,1.0);}`});}
const WNEAR=640, WSEG=256, WSTEP=WNEAR/WSEG;
const wgeo=new THREE.PlaneGeometry(WNEAR,WNEAR,WSEG,WSEG); wgeo.rotateX(-Math.PI/2);
const water=new THREE.Mesh(wgeo,waterMat(1)); water.frustumCulled=false; scene.add(water);
const fgeo=new THREE.PlaneGeometry(3600,3600,4,4); fgeo.rotateX(-Math.PI/2);
const waterFar=new THREE.Mesh(fgeo,waterMat(0)); waterFar.position.y=-0.9; waterFar.frustumCulled=false; scene.add(waterFar);
let simT=0;
function windDirBase(t){return 6*Math.sin(t*0.06)+4*Math.sin(t*0.17+1.2);}
function gust(x,z,t){const zz=z-t*6;return 0.6*Math.sin(x*0.013+0.7)*Math.sin(zz*0.017+1.3)+0.4*Math.sin(x*0.031-zz*0.011+2.0);}
function windAt(x,z,t){const g=gust(x,z,t);return {dir:windDirBase(t)+4*g,tws:15+3*g,g};}
function currentAt(x,z){const s=1.1*Math.exp(-Math.pow((z+140)/60,2));return {x:s,z:0.15*s};}
function buoy(color,r,h){
const g=new THREE.Group();
const body=ink(new THREE.Mesh(new THREE.CylinderGeometry(r*0.7,r,h,20),toon(color)),0.06); body.position.y=h/2-0.3; g.add(body);
const band=ink(new THREE.Mesh(new THREE.CylinderGeometry(r*0.86,r*0.9,h*0.16,20),toon(0xffffff)),0.04); band.position.y=h*0.3; g.add(band);
const pole=ink(new THREE.Mesh(new THREE.CylinderGeometry(0.06,0.06,3,6),toon(0x2a2f36)),0.03); pole.position.y=h+1.2; g.add(pole);
const flag=new THREE.Mesh(new THREE.PlaneGeometry(1.2,0.8),toon(color,{side:THREE.DoubleSide})); flag.position.set(0.6,h+2.2,0); g.add(flag); g.userData.flag=flag;
scene.add(g); return g;
}
const markObj=buoy(0xff6a1a,1.4,2.8); markObj.position.set(MARK.x,0,MARK.z);
const leeObj=buoy(0xff6a1a,1.2,2.4); leeObj.position.set(LEE.x,0,LEE.z);
const pinObj=buoy(0xffb000,0.8,1.6); pinObj.position.set(LINE.x1,0,LINE.z);
const comm=new THREE.Group();
function at(m,x,y,z){m.position.set(x,y,z);return m;}
comm.add(at(ink(new THREE.Mesh(new THREE.BoxGeometry(3,1.4,8),toon(0xf2f2f2)),0.05),0,0.5,0));
comm.add(at(ink(new THREE.Mesh(new THREE.BoxGeometry(2.4,1.4,3),toon(0x0b2540)),0.05),0,1.8,0.8));
comm.add(at(ink(new THREE.Mesh(new THREE.CylinderGeometry(0.05,0.05,5,6),toon(0x333333)),0.03),0,3.5,-1.5));
const cf=new THREE.Mesh(new THREE.PlaneGeometry(1.4,0.9),toon(0xff6a1a,{side:THREE.DoubleSide})); cf.position.set(0.7,5.4,-1.5); comm.add(cf);
comm.position.set(LINE.x2+2,0,LINE.z); scene.add(comm);
[[-620,-500,260],[-200,-760,340],[380,-680,300],[700,-200,280],[660,380,240],[-700,220,300],[-120,720,380],[300,700,220]].forEach(([x,z,s],i)=>{
const c=new THREE.Color(i%2?0x6f9a76:0x5f8a72).lerp(HORIZON,0.42);
const m=new THREE.Mesh(new THREE.SphereGeometry(1,24,12),toon(c,{fog:false}));
m.scale.set(s,s*0.09,s*0.55); m.rotation.y=Math.atan2(x,z); m.position.set(x,-2,z); scene.add(m);
const beach=new THREE.Mesh(new THREE.CylinderGeometry(1,1,1,24),toon(new THREE.Color(0xe8dcb6).lerp(HORIZON,0.42),{fog:false}));
beach.scale.set(s*1.02,2,s*0.56); beach.rotation.y=m.rotation.y; beach.position.set(x,-0.5,z); scene.add(beach);
});
function hullGeo(len,wid,depth){
const shp=new THREE.Shape(), L=len/2;
const o=[[0,-L],[wid*0.45,-L*0.8],[wid*0.8,-L*0.45],[wid,-L*0.05],[wid,L*0.55],[wid*0.92,L],[-wid*0.92,L],[-wid,L*0.55],[-wid,-L*0.05],[-wid*0.8,-L*0.45],[-wid*0.45,-L*0.8]];
o.forEach(([x,z],i)=>i?shp.lineTo(x,-z):shp.moveTo(x,-z));
const g=new THREE.ExtrudeGeometry(shp,{depth,bevelEnabled:true,bevelThickness:0.05,bevelSize:0.04,bevelSegments:2}); g.rotateX(-Math.PI/2); return g;
}
function sailTex(base,accent,num,brand,jib,sh,sf){
const c=document.createElement('canvas');c.width=256;c.height=512;const x=c.getContext('2d');
const t=new THREE.CanvasTexture(c);t.anisotropy=4;
function paint(){
x.clearRect(0,0,256,512);
x.fillStyle=base;x.fillRect(0,0,256,512);
x.strokeStyle='rgba(13,27,42,.16)';x.lineWidth=2;for(let i=1;i<9;i++){x.beginPath();x.moveTo(0,i*58);x.lineTo(256,i*58-34);x.stroke();}
if(!jib){
x.strokeStyle='rgba(13,27,42,.4)';x.lineWidth=6;[0.24,0.44,0.63,0.8].forEach(v=>{const y=(1-v)*512;x.beginPath();x.moveTo(256*0.5,y);x.lineTo(256,y);x.stroke();});
x.fillStyle=accent;x.fillRect(0,512*0.86,256,26);
x.textAlign='center';x.fillStyle='#0d1b2a';x.font='800 70px "Big Shoulders Display", Impact, sans-serif';x.fillText(num,128,512*(1-0.4));
if(brand==='logo'&&LOGO.complete&&LOGO.naturalWidth){
const lh=96, vc=0.25, ratio=LOGO.naturalWidth/LOGO.naturalHeight;
const lw=Math.min(200,lh*(sh/512)*ratio/((sf*(1-vc))/256));
x.drawImage(LOGO,128-lw/2,512*(1-0.34),lw,lh);
} else if(brand){x.fillStyle=accent;x.font='800 36px "Big Shoulders Display", Impact, sans-serif';x.fillText(brand,128,512*(1-0.27));}
} else {x.fillStyle=accent;x.fillRect(0,512*0.9,256,20);}
x.strokeStyle='#0d1b2a';x.lineWidth=12;x.strokeRect(0,0,256,512);
t.needsUpdate=true; if(t._flip)t._flip.needsUpdate=true;
}
paint(); if(brand==='logo'&&!LOGO.complete)LOGO.addEventListener('load',paint);
return t;
}
const SN=8;
function sailMesh(h,foot,tex){
const geo=new THREE.BufferGeometry(), pos=new Float32Array((SN+1)*9), uv=new Float32Array((SN+1)*6);
for(let i=0;i<=SN;i++)for(let j=0;j<3;j++){uv[(i*3+j)*2]=j/2;uv[(i*3+j)*2+1]=i/SN;}
geo.setAttribute('position',new THREE.BufferAttribute(pos,3)); geo.setAttribute('uv',new THREE.BufferAttribute(uv,2));
const idx=[]; for(let i=0;i<SN;i++)for(let j=0;j<2;j++){const a=i*3+j,b=a+3;idx.push(a,b,a+1,a+1,b,b+1);} geo.setIndex(idx);
const flip=tex.clone(); flip.wrapS=THREE.RepeatWrapping; flip.repeat.x=-1; flip.needsUpdate=true;
tex._flip=flip;
const m=new THREE.Mesh(geo,toon(0xffffff,{map:flip,side:THREE.FrontSide}));
m.add(new THREE.Mesh(geo,toon(0xffffff,{map:tex,side:THREE.BackSide})));
m.userData={h,foot}; shapeSail(m,0,1); return m;
}
function shapeSail(m,belly,side){
const {h,foot}=m.userData, p=m.geometry.attributes.position.array;
for(let i=0;i<=SN;i++){const v=i/SN;
for(let j=0;j<3;j++){const c=j/2, k=(i*3+j)*3;
const ly=0.05+v*h, ey=0.05+v*(h-0.05), ez=foot*(1-v);
p[k]=-side*belly*Math.sin(Math.PI*c)*(1-v*0.6); p[k+1]=ly*(1-c)+ey*c; p[k+2]=ez*c;}}
m.geometry.attributes.position.needsUpdate=true; m.geometry.computeVertexNormals();
}
const SKIN=[0xe8b48c,0xc98d63,0x8d5b3d,0xf0c6a0];
function makeSailor(vest,i){
const g=new THREE.Group();
const legs=ink(new THREE.Mesh(new THREE.BoxGeometry(0.26,0.85,0.2),toon(0x1d2633)),0.02); legs.position.y=0.425; g.add(legs);
const torso=ink(new THREE.Mesh(new THREE.BoxGeometry(0.4,0.6,0.3),toon(vest)),0.02); torso.position.y=1.15; g.add(torso);
const head=ink(new THREE.Mesh(new THREE.SphereGeometry(0.13,14,10),toon(SKIN[i%4])),0.02); head.position.y=1.6; g.add(head);
const cap=new THREE.Mesh(new THREE.SphereGeometry(0.14,14,6,0,Math.PI*2,0,Math.PI/2),toon(0xf4f7f6)); cap.position.y=1.63; g.add(cap);
return g;
}
function addCrew(g,parts,vest,list,mastTop){
parts.crew=list.map((c,i)=>{
const s=makeSailor(vest,i+(vest&7)); g.add(s);
const wg=new THREE.BufferGeometry(); wg.setAttribute('position',new THREE.BufferAttribute(new Float32Array(6),3));
const wire=new THREE.Line(wg,new THREE.LineBasicMaterial({color:0x0d1b2a})); wire.visible=false; wire.frustumCulled=false; g.add(wire);
return Object.assign({g:s,wire},c);
});
parts.mastTop=mastTop;
}
function makeBoat(type,o){
const g=new THREE.Group(), white=toon(0xf7f7f3), deck=toon(0xc9d1d6), alu=toon(0xb9c2c9), dark=toon(0x22313f), acc=toon(o.accent);
const parts={group:g};
const mainTex=sailTex(o.base,o.css,o.num,o.brand,false,type==='cat'?7.8:5.6,type==='cat'?2.65:2.85), jibTex=sailTex(o.base,o.css,'','',true);
if(type==='dinghy'){
const hull=ink(new THREE.Mesh(hullGeo(4.3,0.68,0.32),white),0.04); hull.position.y=-0.05; g.add(hull);
const boot=new THREE.Mesh(hullGeo(4.32,0.69,0.08),acc); boot.position.y=-0.02; g.add(boot);
const dk=new THREE.Mesh(hullGeo(3.6,0.5,0.04),deck); dk.position.set(0,0.31,0.25); g.add(dk);
const rud=ink(new THREE.Mesh(new THREE.BoxGeometry(0.05,0.9,0.3),dark),0.02); rud.position.set(0,-0.2,2.25); g.add(rud);
const mast=ink(new THREE.Mesh(new THREE.CylinderGeometry(0.045,0.06,6.4,8),alu),0.02); mast.position.set(0,3.4,-0.9); g.add(mast);
const bp=new THREE.Group(); bp.position.set(0,0.95,-0.9); g.add(bp);
const boom=ink(new THREE.Mesh(new THREE.CylinderGeometry(0.045,0.045,2.9,8),alu),0.02); boom.rotation.x=Math.PI/2; boom.position.z=1.45; bp.add(boom);
const main=sailMesh(5.6,2.85,mainTex); bp.add(main);
const jp=new THREE.Group(); jp.position.set(0,0.4,-1.95); g.add(jp);
const jib=sailMesh(3.9,1.15,jibTex); jib.rotation.x=0.27; jp.add(jib);
Object.assign(parts,{boomPivot:bp,main,jibPivot:jp,jib});
addCrew(g,parts,o.accent,[{trap:false,z:1.25,edge:0.62,deck:0.33},{trap:true,z:-0.2,edge:0.66,deck:0.33}],[0,4.7,-0.9]);
} else {
[-1.2,1.2].forEach(x=>{
const h=ink(new THREE.Mesh(hullGeo(5.6,0.3,0.45),white),0.04); h.position.set(x,-0.05,0); g.add(h);
const b=new THREE.Mesh(hullGeo(5.62,0.31,0.1),acc); b.position.set(x,-0.03,0); g.add(b);
const r=ink(new THREE.Mesh(new THREE.BoxGeometry(0.04,0.8,0.28),dark),0.02); r.position.set(x,-0.3,2.85); g.add(r);
});
const tramp=ink(new THREE.Mesh(new THREE.BoxGeometry(2.1,0.04,2.6),dark),0.02); tramp.position.set(0,0.48,0.6); g.add(tramp);
[-0.7,1.9].forEach(z=>{const b=ink(new THREE.Mesh(new THREE.BoxGeometry(2.7,0.12,0.14),alu),0.02); b.position.set(0,0.5,z); g.add(b);});
const mast=ink(new THREE.Mesh(new THREE.CylinderGeometry(0.06,0.08,9,8),alu),0.025); mast.position.set(0,5,-0.6); g.add(mast);
const bp=new THREE.Group(); bp.position.set(0,1.1,-0.6); g.add(bp);
const boom=ink(new THREE.Mesh(new THREE.CylinderGeometry(0.05,0.05,2.7,8),alu),0.02); boom.rotation.x=Math.PI/2; boom.position.z=1.35; bp.add(boom);
const main=sailMesh(7.8,2.65,mainTex); bp.add(main);
const jp=new THREE.Group(); jp.position.set(0,0.65,-2.7); g.add(jp);
const jib=sailMesh(5.2,1.7,jibTex); jib.rotation.x=0.36; jp.add(jib);
Object.assign(parts,{boomPivot:bp,main,jibPivot:jp,jib});
addCrew(g,parts,o.accent,[{trap:true,z:0.1,edge:1.5,deck:0.45},{trap:true,z:1.2,edge:1.5,deck:0.45}],[0,6.3,-0.6]);
}
parts.wake=new THREE.Group(); scene.add(parts.wake);
parts.hullWakes=(type==='cat'?[-1.2,1.2]:[0]).map(off=>{const mesh=newWake(48);scene.remove(mesh);parts.wake.add(mesh);return {mesh,trail:[],off};});
parts.bowSpray=type==='cat'?makeBowSpray(-2.4,[-1.2,1.2]):makeBowSpray(-1.85,[0]); g.add(parts.bowSpray);
scene.add(g); return parts;
}
const SPN=900, spGeo=new THREE.BufferGeometry();
const spPos=new Float32Array(SPN*3), spA=new Float32Array(SPN), spS=new Float32Array(SPN), spV=new Float32Array(SPN*3), spL=new Float32Array(SPN), spSeed=new Float32Array(SPN).map(()=>Math.random());
spGeo.setAttribute('position',new THREE.BufferAttribute(spPos,3));
spGeo.setAttribute('a',new THREE.BufferAttribute(spA,1));
spGeo.setAttribute('sz',new THREE.BufferAttribute(spS,1));
spGeo.setAttribute('seed',new THREE.BufferAttribute(spSeed,1));
const spMat=new THREE.ShaderMaterial({transparent:true,depthWrite:false,uniforms:{scale:{value:500}},
vertexShader:'attribute float a;attribute float sz;attribute float seed;uniform float scale;varying float va;varying float vs;void main(){va=a;vs=seed;vec4 mv=modelViewMatrix*vec4(position,1.0);gl_PointSize=sz*scale/max(0.5,-mv.z);gl_Position=projectionMatrix*mv;}',
fragmentShader:`varying float va;varying float vs;void main(){
vec2 p=gl_PointCoord-0.5; float m=0.0, e=0.0;
for(int i=0;i<4;i++){float fi=float(i);float an=vs*6.283+fi*1.9;
vec2 c=vec2(cos(an),sin(an))*0.24*(0.35+fract(vs*7.3+fi*0.37));
float r=0.07+0.1*fract(vs*13.1+fi*0.71); float d=length(p-c);
m=max(m,step(d,r)); e=max(e,step(d,r)*step(r-0.035,d));}
if(m<0.5||va<0.01)discard;
gl_FragColor=vec4(mix(vec3(0.98,1.0,1.0),vec3(0.7,0.86,0.93),e),va);}`});
const spray=new THREE.Points(spGeo,spMat); spray.frustumCulled=false; scene.add(spray);
let spI=0;
function emitSpray(x,y,z,vx,vy,vz,size){const i=spI;spI=(spI+1)%SPN;spSeed[i]=Math.random();spPos[i*3]=x;spPos[i*3+1]=y;spPos[i*3+2]=z;spV[i*3]=vx;spV[i*3+1]=vy;spV[i*3+2]=vz;spL[i]=0.6+Math.random()*0.5;spS[i]=size;spA[i]=0.95;}
function updateSpray(dt){
for(let i=0;i<SPN;i++){
if(spL[i]<=0){spA[i]=0;continue;}
spL[i]-=dt; spV[i*3+1]-=9.8*dt;
spPos[i*3]+=spV[i*3]*dt; spPos[i*3+1]+=spV[i*3+1]*dt; spPos[i*3+2]+=spV[i*3+2]*dt;
spA[i]=Math.max(0,Math.min(1,spL[i]*2.2))*0.95;
}
spGeo.attributes.position.needsUpdate=true; spGeo.attributes.a.needsUpdate=true; spGeo.attributes.sz.needsUpdate=true; spGeo.attributes.seed.needsUpdate=true;
}
function makeBowSpray(bowZ,xs){
const g=new THREE.Group(), mat=new THREE.MeshBasicMaterial({color:0xf4fbfd,transparent:true,opacity:0,side:THREE.DoubleSide,depthWrite:false});
const edge=new THREE.MeshBasicMaterial({color:0x9fd0e0,transparent:true,opacity:0,side:THREE.DoubleSide,depthWrite:false});
xs.forEach(x0=>[-1,1].forEach(side=>{
const pts=[0,0,0], N=7;
for(let t=0;t<=N;t++){const f=t/N, h=Math.sin(Math.PI*Math.min(1,f*1.15))*0.95*(t%2?0.72:1);
pts.push(side*(0.18+f*1.5),h,f*1.7);}
const geo=new THREE.BufferGeometry(); geo.setAttribute('position',new THREE.Float32BufferAttribute(pts,3));
const idx=[]; for(let t=1;t<=N;t++)idx.push(0,t,t+1); geo.setIndex(idx);
const m=new THREE.Mesh(geo,mat); m.position.set(x0,0.02,bowZ); g.add(m);
const lpts=[]; for(let t=1;t<=N+1;t++)lpts.push(pts[t*3],pts[t*3+1],pts[t*3+2]);
const lg=new THREE.BufferGeometry(); lg.setAttribute('position',new THREE.Float32BufferAttribute(lpts,3));
const ln=new THREE.Line(lg,new THREE.LineBasicMaterial({color:0x0d1b2a,transparent:true,opacity:0})); ln.position.copy(m.position); g.add(ln);
}));
g.userData={mat,edge,lines:g.children.filter(c=>c.isLine)}; g.visible=false; return g;
}
function boatSpray(b,yb,fx,fz,L){
const rise=(yb-(b.prevYb===undefined?yb:b.prevYb))/Math.max(frameDt,1e-3); b.prevYb=yb;
const g=b.w?Math.max(0,b.w.g):0;
const fan=b.m.bowSpray;
if(fan&&!b.doc){
const tgt=b.v<2.5?0:Math.min(1,Math.max(0,(rise-0.05)*1.1+g*0.15+(b.v-2.5)*0.04))*Math.min(1,b.v/6);
b.fanI=(b.fanI||0)+(tgt-(b.fanI||0))*Math.min(1,frameDt*(tgt>(b.fanI||0)?10:3));
fan.visible=b.fanI>0.03; fan.scale.set(0.6+0.4*b.fanI,b.fanI*1.3,0.5+0.6*b.fanI);
fan.userData.mat.opacity=Math.min(0.9,b.fanI*1.6); fan.userData.lines.forEach(l=>l.material.opacity=Math.min(0.8,b.fanI*1.4));
}
if(b.v<2.5||state==='menu')return;
const d=Math.hypot(b.x-camera.position.x,b.z-camera.position.z); if(d>160)return;
b.spAcc=(b.spAcc||0)+frameDt*(Math.max(0,rise-0.15)*55+g*4)*Math.min(1.5,b.v/6);
const hulls=clsKey==='cat'?[-1.2,1.2]:[0], rx=-fz, rz=fx, sp=b.v*KN;
while(b.spAcc>=1){b.spAcc-=1;
for(const hx of hulls)for(const side of [-1,1]){
const bx=b.x+fx*L*0.85+rx*(hx+side*0.35), bz=b.z+fz*L*0.85+rz*(hx+side*0.35), out=1.2+Math.random()*2.2;
for(let q=0;q<2;q++){const up=1.8+Math.random()*2.8+rise*1.4, back=0.1+Math.random()*0.3;
emitSpray(bx,yb+0.2,bz, rx*side*out+fx*sp*back, up, rz*side*out+fz*sp*back, 0.28+Math.random()*0.35);}
}
}
}
const wakeMat=new THREE.ShaderMaterial({transparent:true,depthWrite:false,side:THREE.DoubleSide,
vertexShader:'attribute float a;attribute float s;varying float va;varying float vs;void main(){va=a;vs=s;gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0);}',
fragmentShader:'varying float va;varying float vs;void main(){float e=abs(vs);float edge=step(0.74,e)*0.9;float core=(1.0-smoothstep(0.0,0.55,e))*0.8;float k=max(edge,core)+0.12;gl_FragColor=vec4(0.96,0.99,1.0,va*k);}'});
function updateHullWakes(b,dt){
const m=b.m, Lh=clsKey==='cat'?2.8:2.15, fx=Math.sin(b.h*D2R), fz=-Math.cos(b.h*D2R), WN=48, maxA=WN*0.09;
m.wt=(m.wt||0)-dt; const add=m.wt<=0&&state!=='menu'; if(add)m.wt=0.09;
m.hullWakes.forEach(w=>{
const tr=w.trail;
if(add){tr.push({x:b.x-fx*Lh-fz*w.off,z:b.z-fz*Lh+fx*w.off,h:b.h,v:b.v,t:simT}); if(tr.length>WN)tr.shift();}
const pos=w.mesh.geometry.attributes.position.array, al=w.mesh.geometry.attributes.a.array;
for(let i=0;i<WN;i++){
const p=tr[tr.length-1-i];
if(!p){al[i*2]=al[i*2+1]=0;continue;}
const age=simT-p.t, wd=(clsKey==='cat'?0.22:0.32)+age*0.75, cx=Math.cos(p.h*D2R)*wd, cz=Math.sin(p.h*D2R)*wd;
const y0=waveY(p.x-cx,p.z-cz,simT)+0.16, y1=waveY(p.x+cx,p.z+cz,simT)+0.16;
pos.set([p.x-cx,y0,p.z-cz,p.x+cx,y1,p.z+cz],i*6);
const a=Math.pow(Math.max(0,1-age/maxA),1.3)*Math.min(1,Math.max(0,(p.v-7)/4))*0.85; al[i*2]=al[i*2+1]=a;   // apparaît à partir de 7 nœuds
}
w.mesh.geometry.attributes.position.needsUpdate=true; w.mesh.geometry.attributes.a.needsUpdate=true;
});
}
function updateWake(b,dt){
const m=b.m, tr=m.trail, Lh=b.wakeL||(clsKey==='cat'?2.8:2.1);
m.wt=(m.wt||0)-dt;
if(m.wt<=0&&state!=='menu'){m.wt=0.1;
tr.push({x:b.x-Math.sin(b.h*D2R)*Lh,z:b.z+Math.cos(b.h*D2R)*Lh,h:b.h,v:b.v,t:simT}); if(tr.length>m.WN)tr.shift();}
const pos=m.wake.geometry.attributes.position.array, al=m.wake.geometry.attributes.a.array, maxA=m.WN*0.1, w0=b.wakeW||(clsKey==='cat'?1.6:0.45);
for(let i=0;i<m.WN;i++){
const p=tr[tr.length-1-i];
if(!p){al[i*2]=al[i*2+1]=0;continue;}
const age=simT-p.t, w=w0+age*0.9, cx=Math.cos(p.h*D2R)*w, cz=Math.sin(p.h*D2R)*w;
const y0=waveY(p.x-cx,p.z-cz,simT)+0.16, y1=waveY(p.x+cx,p.z+cz,simT)+0.16;
pos.set([p.x-cx,y0,p.z-cz,p.x+cx,y1,p.z+cz],i*6);
const a=Math.max(0,1-age/maxA)*Math.min(1,p.v/4)*0.8; al[i*2]=al[i*2+1]=a;
}
m.wake.geometry.attributes.position.needsUpdate=true; m.wake.geometry.attributes.a.needsUpdate=true;
}
function newWake(WN){
const wk=new THREE.BufferGeometry();
wk.setAttribute('position',new THREE.BufferAttribute(new Float32Array(WN*2*3),3));
wk.setAttribute('a',new THREE.BufferAttribute(new Float32Array(WN*2),1));
wk.setAttribute('s',new THREE.BufferAttribute(new Float32Array(WN*2).map((_,i)=>i%2?1:-1),1));
const wi=[];for(let i=0;i<WN-1;i++){const a=i*2;wi.push(a,a+1,a+2,a+1,a+3,a+2);} wk.setIndex(wi);
const wake=new THREE.Mesh(wk,wakeMat); wake.frustumCulled=false; scene.add(wake); return wake;
}
const ribs=[[70,-150,55,0.05,0xd7dde2],[-85,-40,40,-0.07,0xe7e2d4],[90,40,30,0.09,0x9aa7b1]].map(([cx,cz,R,w,col],i)=>{
const g=new THREE.Group();
const hull=ink(new THREE.Mesh(hullGeo(5.2,0.95,0.55),toon(0x2b3640)),0.05); hull.position.y=-0.1; g.add(hull);
const tube=new THREE.Mesh(hullGeo(5.3,1.02,0.3),toon(col)); tube.position.y=0.25; g.add(tube);
const cons=ink(new THREE.Mesh(new THREE.BoxGeometry(0.7,0.9,0.6),toon(0xf2f2f2)),0.03); cons.position.set(0,0.9,0.3); g.add(cons);
const mot=ink(new THREE.Mesh(new THREE.BoxGeometry(0.45,0.9,0.45),toon(0x1d2633)),0.03); mot.position.set(0,0.5,2.75); g.add(mot);
const pilot=makeSailor([0xff6a1a,0x4fa3e0,0xf2c14e][i],i); pilot.position.set(0,0.4,0.95); pilot.scale.y=0.9; g.add(pilot);
scene.add(g);
return {g,cx,cz,R,w,ph:i*2.1,x:0,z:0,h:0,v:0,m:{wake:newWake(30),trail:[],WN:30},wakeW:0.7,wakeL:2.6};
});
function updateRibs(dt){
ribs.forEach(r=>{
const a=simT*r.w+r.ph, nx=r.cx+r.R*Math.cos(a), nz=r.cz+r.R*1.7*Math.sin(a);
const dx=nx-r.x, dz=nz-r.z; r.v=Math.hypot(dx,dz)/Math.max(dt,1e-3)/KN;
if(r.v>0.01)r.h=Math.atan2(dx,-dz)*R2D;
r.x=nx; r.z=nz;
const y=waveY(r.x,r.z,simT);
r.g.position.set(r.x,y,r.z); r.g.rotation.order='YXZ'; r.g.rotation.set(0.06,-r.h*D2R,Math.sin(simT*1.3+r.ph)*0.04);
updateWake(r,dt);
});
}
const gulls=[...Array(7)].map((_,i)=>{
const g=new THREE.Group(), mat=toon(0xfafafa), tip=toon(0x2b2f36);
const body=ink(new THREE.Mesh(new THREE.SphereGeometry(0.22,10,8),mat),0.02); body.scale.set(0.8,0.7,2); g.add(body);
const wings=[-1,1].map(s=>{const p=new THREE.Group(); const w=ink(new THREE.Mesh(new THREE.BoxGeometry(0.9,0.04,0.32),mat),0.015); w.position.x=s*0.5; p.add(w);
const t=new THREE.Mesh(new THREE.BoxGeometry(0.3,0.045,0.26),tip); t.position.x=s*1.05; p.add(t); g.add(p); return p;});
scene.add(g); return {g,wings,r:18+i*7,hgt:14+(i%3)*5,sp:0.25+((i*37)%10)/40,ph:i*0.9};
});
function updateGulls(){
gulls.forEach((b,i)=>{
const a=simT*b.sp+b.ph, cx=me.x+20*Math.sin(simT*0.05+i), cz=me.z-25+15*Math.cos(simT*0.04+i);
b.g.position.set(cx+b.r*Math.cos(a),b.hgt+1.5*Math.sin(simT*0.7+i),cz+b.r*Math.sin(a));
b.g.rotation.set(0,Math.PI-a,0.35);
const flap=Math.sin(simT*(i%2?7:5.5)+i)*0.55*(0.5+0.5*Math.sin(simT*0.4+i*1.7)>0.3?1:0.15);
b.wings[0].rotation.z=flap; b.wings[1].rotation.z=-flap;
});
}
let cls=CLASSES.dinghy, clsKey='dinghy', fleet=[], me=null, viewMode='chase';
let series={race:1,results:[]};  // results : une liste de {nom: place} par course
function newBoat(opt){return Object.assign({h:360-cls.startH,x:0,z:70,v:0,rudder:0,rIn:0,sheet:0.35,heel:0,side:1,twa:45,eff:1,trim:'ok',phase:0,prevZ:70,finish:null,lastHit:-99,lastSwitch:-99,targetH:360-cls.startH,think:0},opt);}
function buildFleet(withAI){
fleet.forEach(b=>{scene.remove(b.m.group);scene.remove(b.m.wake);}); fleet=[];
me=newBoat({name:'Vous',css:'#ff6a1a',ai:false,x:0,x0:0});
me.m=makeBoat(clsKey,{base:'#fbfbf7',css:'#ff6a1a',accent:0xff6a1a,num:'FRA 56',brand:'logo'}); fleet.push(me);
if(withAI!==false)RIVALS.forEach((r,i)=>{const b=newBoat({name:r.name,css:r.css,ai:true,skill:Math.min(1.06,r.skill*LEVEL[series.race-1]),x:r.x,x0:r.x,z:66+(i%2)*12,prevZ:66+(i%2)*12,seed:i*1.7,h:360-cls.startH});
b.targetH=b.h; b.m=makeBoat(clsKey,{base:'#'+new THREE.Color(r.col).lerp(new THREE.Color(0xffffff),0.72).getHexString(),css:r.css,accent:r.col,num:'FRA '+(12+i*17)}); fleet.push(b);});
}
const keys={};
addEventListener('keydown',e=>{keys[e.key]=true; if(e.key.startsWith('Arrow'))e.preventDefault(); if(e.key==='v'||e.key==='c')toggleView();});
addEventListener('keyup',e=>{keys[e.key]=false;});
function holdBtn(el,val){
const on=e=>{e.preventDefault();if(me)me.rIn=val;el.classList.add('on');el.setPointerCapture&&el.setPointerCapture(e.pointerId);};
const off=()=>{if(me&&me.rIn===val)me.rIn=0;el.classList.remove('on');};
el.addEventListener('pointerdown',on); el.addEventListener('pointerup',off); el.addEventListener('pointercancel',off); el.addEventListener('lostpointercapture',off);
}
holdBtn($('bl'),-1); holdBtn($('br'),1);
const sheetEl=$('sheet');
function setSheetFromY(cy){if(!me)return;const r=sheetEl.getBoundingClientRect(); me.sheet=Math.min(1,Math.max(0,(cy-r.top-24)/(r.height-48)));}
sheetEl.addEventListener('pointerdown',e=>{sheetEl.setPointerCapture(e.pointerId);setSheetFromY(e.clientY);});
sheetEl.addEventListener('pointermove',e=>{if(sheetEl.hasPointerCapture(e.pointerId))setSheetFromY(e.clientY);});
function toggleView(){viewMode=viewMode==='chase'?'helm':'chase'; $('view').textContent='VUE : '+(viewMode==='chase'?'POURSUITE':'À LA BARRE');}
$('view').onclick=toggleView;
(function(){
const own=new Set(document.body.children);
const hide=n=>{if(n.nodeType===1&&!own.has(n)&&n.id!=='pause'&&!/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(n.tagName))n.style.setProperty('display','none','important');};
new MutationObserver(ms=>ms.forEach(m=>m.addedNodes.forEach(hide))).observe(document.body,{childList:true});
})();
(function(){
const el=document.documentElement, b=$('fs');
const req=el.requestFullscreen||el.webkitRequestFullscreen, exit=document.exitFullscreen||document.webkitExitFullscreen;
if(!req||!(document.fullscreenEnabled||document.webkitFullscreenEnabled))return;
b.hidden=false;
const cur=()=>document.fullscreenElement||document.webkitFullscreenElement;
const label=()=>{b.textContent=cur()?'QUITTER LE PLEIN ÉCRAN':'PLEIN ÉCRAN';};
b.onclick=()=>{try{const r=cur()?exit.call(document):req.call(el,{navigationUI:'hide'});if(r&&r.catch)r.catch(()=>{});}catch(e){}};
window.goFull=()=>{if(!cur()&&matchMedia('(pointer:coarse)').matches){try{const r=req.call(el,{navigationUI:'hide'});if(r&&r.catch)r.catch(()=>{});}catch(e){}}};
document.addEventListener('fullscreenchange',label); document.addEventListener('webkitfullscreenchange',label);
})();
let msgTimer=0, state='menu', t0=0, count=0, lastN=null;
function flash(t,d=1.8){const m=$('msg');m.textContent=t;m.style.opacity=1;msgTimer=d;}
function hint(t,color){const h=$('hint'); if(!t){h.style.opacity=0;return;} h.textContent=t;h.style.color=color||'#f4f7f6';h.style.opacity=1;}
const norm=a=>((a+180)%360+360)%360-180;
function polar(twa){
if(twa<cls.min)return 0; const p=cls.pts;
for(let i=1;i<p.length;i++)if(twa<=p[i][0]){const[a0,b0]=p[i-1],[a1,b1]=p[i];return b0+(b1-b0)*(twa-a0)/(a1-a0);}
return p[p.length-1][1];
}
const idealSheet=twa=>Math.min(1,Math.max(0,cls.ideal(twa)));
function targetOf(b){
if(state==='count')return b.launch?{x:b.x0,z:-12}:{x:b.x0,z:45};
if(b.ocs)return {x:b.x0,z:8};
if(b.phase===0||b.phase===2)return {x:MARK.x+7,z:MARK.z-8};   // laissée à bâbord : on passe à l'est
if(b.phase===1)return {x:LEE.x-7,z:LEE.z+8};                   // laissée à bâbord en descendant : on passe à l'ouest
return {x:b.ai?((b.seed*13)%120)-60:0,z:LINE.z+6};
}
function aiThink(b){
b.preSlow=1;
if(state==='count'){
const vExp=polar(cls.min+9)*12*cls.k*KN*0.72*b.skill;   // vitesse de remontée attendue
b.launch=count<=Math.max(0,b.z)/vExp+(clsKey==="cat"?9:6); if(b.launch)b.waiting=false;
if(!b.launch){
if(Math.hypot(b.x0-b.x,45-b.z)<14||b.waiting){ // zone d'attente : bout au vent, le bateau s'arrête
b.waiting=true; b.targetH=windDirBase(simT)-(b.tack||1)*8; return;
}
} else {
const vm=Math.max(0.3,-Math.cos(b.h*D2R)*b.v*KN);
if(b.z/vm<count-1.5)b.preSlow=0.45;           // en avance : on freine pour ne pas partir trop tôt
}
}
const w=windAt(b.x,b.z,simT), t=targetOf(b);
const brg=Math.atan2(t.x-b.x,-(t.z-b.z))*R2D;
const best={1:{v:-1e9,h:0},[-1]:{v:-1e9,h:0}};
for(const s of [1,-1])for(let twa=cls.min+2;twa<=180;twa+=3){
const h=w.dir-s*twa, vm=polar(twa)*w.tws*Math.cos(norm(h-brg)*D2R);
if(vm>best[s].v)best[s]={v:vm,h};
}
let s=b.tack||(norm(w.dir-b.h)>=0?1:-1);
if(best[-s].v>best[s].v*1.12+0.25&&simT-b.lastSwitch>6){s=-s;b.lastSwitch=simT;}
b.tack=s; b.targetH=best[s].h+Math.sin(simT*0.25+b.seed)*Math.max(0.03,1-b.skill)*30;
}
function stepBoat(b,dt,racing){
b.slowF=1;
if(b.ai){
if(racing&&!b.finish){b.think-=dt;if(b.think<=0){aiThink(b);b.think=0.35;}}
let th=b.targetH;
if(b.avoid&&racing&&!b.finish){
const W=b.w?b.w.dir:0, safe=cls.minD*2.2, v=Math.max(b.v,1.5)*KN;
let best=null;
for(const off of [0,-15,15,-30,30,-45,45,-65,65,-90,90]){
const hc=b.targetH+off, r=norm(W-hc); if(Math.abs(r)<cls.min+2)continue;
let md=1e9;
for(const o of b.avoid)for(let t=0;t<=4;t+=0.25){
const dx=o.x+Math.sin(o.h*D2R)*o.v*KN*t-(b.x+Math.sin(hc*D2R)*v*t), dz=o.z-Math.cos(o.h*D2R)*o.v*KN*t-(b.z-Math.cos(hc*D2R)*v*t);
md=Math.min(md,Math.hypot(dx,dz));
}
const sc=Math.min(md,safe)-Math.abs(off)*0.015;
if(!best||sc>best.sc)best={sc,hc,md};
}
if(best){th=best.hc; if(best.md<cls.minD*1.4)b.slowF=0.4;}
}
const err=norm(th-b.h); b.rIn=Math.max(-1,Math.min(1,err/12));
} else {
let inp=b.rIn; if(keys.ArrowLeft||keys.a||keys.q)inp=-1; if(keys.ArrowRight||keys.d)inp=1; b.rInEff=inp;
if(keys.ArrowUp||keys.w||keys.z)b.sheet=Math.max(0,b.sheet-dt*0.55);
if(keys.ArrowDown||keys.s)b.sheet=Math.min(1,b.sheet+dt*0.55);
}
const inp=b.ai?b.rIn:b.rInEff;
b.rudder+=Math.sign(inp-b.rudder)*Math.min(Math.abs(inp-b.rudder),dt*3.5);
const w=windAt(b.x,b.z,simT); b.w=w;
const rel=norm(w.dir-b.h); b.side=rel>=0?1:-1; b.twa=Math.abs(rel);
const ideal=idealSheet(b.twa);
if(b.ai)b.sheet+= (ideal-b.sheet)*Math.min(1,dt*2);
const diff=b.sheet-ideal; let eff=1,trim='ok';
if(diff>0.12){eff=Math.max(0.08,1-(diff-0.12)*4.2);trim='luff';}
else if(diff<-0.12){eff=Math.max(0.3,1-(-diff-0.12)*2.6);trim='tight';}
if(b.ai)eff*=b.skill*b.slowF*(b.preSlow||1);
b.eff=eff;b.trim=trim;
const go=racing&&!b.finish;
const target=(racing||b.finish)?polar(b.twa)*w.tws*cls.k*eff:0;
b.v+=(target-b.v)*Math.min(1,dt*(target>b.v?0.55:0.35));
if(racing||b.finish){
b.h=(b.h+(cls.turnB+b.v*cls.turnV)*b.rudder*dt+360)%360;
b.v=Math.max(0,b.v-Math.abs(b.rudder)*dt*cls.rudLoss*b.v);
const c=currentAt(b.x,b.z); b.prevZ=b.z;
b.x+=(Math.sin(b.h*D2R)*b.v+c.x)*KN*dt;
b.z+=(-Math.cos(b.h*D2R)*b.v+c.z)*KN*dt;
}
const heelT=b.side*Math.min(cls.heelMax,(b.v/(cls.k*13))*cls.heelMax*1.1*Math.sin(Math.min(b.twa,110)*D2R)*(1+0.5*Math.max(0,w.g)))*(trim==='luff'?0.3:1);
b.load=Math.min(1,Math.abs(heelT)/cls.heelMax);
if(b.cs===undefined){b.cs=b.side;b.tf=0;}
b.cs+=(b.side-b.cs)*Math.min(1,dt*2.2);                         // les équipiers changent de bord au virement
const tfT=Math.abs(b.cs)>0.85?Math.min(1,Math.max(0,(b.load-0.3)/0.35)):0;
b.tf+=(tfT-b.tf)*Math.min(1,dt*1.6);
b.heel+=(heelT*(1-0.4*b.tf)-b.heel)*Math.min(1,dt*1.5);
}
let pairMem={};
function giveWay(a,b){
if(a.side!==b.side)return a.side<0?a:b;            // règle 10
const hx=Math.sin(a.h*D2R)+Math.sin(b.h*D2R), hz=-Math.cos(a.h*D2R)-Math.cos(b.h*D2R), hn=Math.hypot(hx,hz)||1;
const along=((a.x-b.x)*hx+(a.z-b.z)*hz)/hn, L=cls.minD*1.2;
if(along>L)return b; if(along<-L)return a;
const key=a.name+'|'+b.name, m=pairMem[key];
if(m&&simT-m.t<1.5&&m.side===a.side)return m.g;
const W=windDirBase(simT)*D2R, d=(a.x-b.x)*Math.sin(W)-(a.z-b.z)*Math.cos(W);
const g=d>0?a:b; pairMem[key]={g,t:simT,side:a.side}; return g;
}
let meWarn=null;
function rightOfWay(){
fleet.forEach(b=>b.avoid=null); meWarn=null;
for(let i=0;i<fleet.length;i++)for(let j=i+1;j<fleet.length;j++){
const a=fleet[i],b=fleet[j]; if(a.finish||b.finish)continue;
if(mode==='ghost'&&(a===me||b===me))continue;   // contre-la-montre : les concurrents ne gênent pas le chrono
const dx=b.x-a.x,dz=b.z-a.z,dist=Math.hypot(dx,dz); if(dist>45)continue;
const rvx=(Math.sin(b.h*D2R)*b.v-Math.sin(a.h*D2R)*a.v)*KN, rvz=(-Math.cos(b.h*D2R)*b.v+Math.cos(a.h*D2R)*a.v)*KN;
const rv2=rvx*rvx+rvz*rvz, tc=rv2>1e-4?Math.max(0,Math.min(5,-(dx*rvx+dz*rvz)/rv2)):0;
if(Math.hypot(dx+rvx*tc,dz+rvz*tc)>cls.minD*1.9)continue;
const g=giveWay(a,b), o=g===a?b:a, port=a.side!==b.side, withMe=a===me||b===me;
if(g.ai&&!g.holds)(g.avoid||(g.avoid=[])).push(o);
else if(!meWarn||dist<meWarn.dist)meWarn={port,o,dist,astern:!port&&((o.x-me.x)*Math.sin(me.h*D2R)-(o.z-me.z)*Math.cos(me.h*D2R))>cls.minD*1.2};
}
}
function separate(){
for(let i=0;i<fleet.length;i++)for(let j=i+1;j<fleet.length;j++){
const a=fleet[i],b=fleet[j],dx=b.x-a.x,dz=b.z-a.z,d=Math.hypot(dx,dz);
if(mode==='ghost'&&(a===me||b===me))continue;
if(d<cls.minD&&d>0.01){const p=(cls.minD-d)/2,nx=dx/d,nz=dz/d;a.x-=nx*p;a.z-=nz*p;b.x+=nx*p;b.z+=nz*p;a.v*=0.985;b.v*=0.985;
if((state!=='race'&&state!=='count')||a.finish||b.finish)continue;
if(a!==me&&b!==me){const k2=a.name+b.name;if(simT-(bumps[k2]||-9)>4){bumps[k2]=simT;const dm2=Math.hypot(a.x-me.x,a.z-me.z);if(dm2<60)thump(0.5*(1-dm2/60));}continue;}  // pénalités seulement dans les situations avec le joueur
const g=giveWay(a,b), o=g===a?b:a, key=Math.min(i,j)+'-'+Math.max(i,j);
if(simT-(bumps[key]||-9)<4)continue; bumps[key]=simT;
const why=a.side!==b.side?'bâbord amures':'mêmes amures';
thump(1);
if(g===me){penalty+=10;flash(`Refus de priorité (${why}) : +10 s`,2.2);}
else{g.pen=(g.pen||0)+10;if(o===me)flash(`${g.name} vous a refusé la priorité : +10 s pour lui`,2.2);}
}
}
}
let bumps={};
function rules(b){
if(b.finish)return;
if(!b.ai){
const dm=Math.hypot(b.x-MARK.x,b.z-MARK.z),dl=Math.hypot(b.x-LEE.x,b.z-LEE.z),dp=Math.hypot(b.x-LINE.x1,b.z),dc=Math.hypot(b.x-(LINE.x2+2),b.z);
if((dm<2.6||dl<2.4||dp<1.8||dc<3.4)&&simT-b.lastHit>4){penalty+=10;b.lastHit=simT;b.v*=0.3;thump(0.8);flash('Contact avec la bouée ! +10 s');}
}
if(b.ocs){if(b.z>LINE.z+1){b.ocs=false;if(!b.ai)flash('Départ réparé, en route !',1.6);}return;}
if((b.phase===0||b.phase===2)&&b.z<MARK.z-2&&Math.abs(b.x-MARK.x)<70){
b.phase++; if(!b.ai){flash(b.phase===1?'Bouée au vent · cap sur la bouée sous le vent':'Dernière bouée · cap sur l’arrivée');ding();}}
if(b.phase===1&&b.z>LEE.z+2&&Math.abs(b.x-LEE.x)<70){b.phase=2;if(!b.ai){flash('Tour 2 · remontez à la bouée au vent');ding();}}
if(b.phase===3&&b.prevZ<LINE.z&&b.z>=LINE.z&&b.x>LINE.x1&&b.x<LINE.x2){
b.finish=(simT-t0)+(b.ai?(b.pen||0):penalty); b.phase=4; b.targetH=180;
if(!b.ai)(mode==='ghost'?endGhost:endRace)();
}
}
function progress(b){
if(b.finish)return 1e6-b.finish;
const t=targetOf(b); return b.phase*1000-Math.hypot(t.x-b.x,t.z-b.z);
}
function rankOf(b){return 1+fleet.filter(o=>o!==b&&progress(o)>progress(b)).length;}
const mapC=$('map'), mctx=mapC.getContext('2d'), vaneC=$('vane'), vctx=vaneC.getContext('2d');
function sizeCanvas(c){const r=c.getBoundingClientRect(),d=Math.min(devicePixelRatio,2);c.width=r.width*d;c.height=r.height*d;c.dpr=d;}
function drawMap(){
const W=mapC.width,H=mapC.height,ctx=mctx,k=mapC.dpr; ctx.clearRect(0,0,W,H);
const x0=-160,x1=160,z0=-330,z1=70,sx=W/(x1-x0),sz=H/(z1-z0),P=(x,z)=>[(x-x0)*sx,(z-z0)*sz];
const n=16;
for(let i=0;i<n;i++)for(let j=0;j<n;j++){const x=x0+(i+0.5)*(x1-x0)/n,z=z0+(j+0.5)*(z1-z0)/n,g=gust(x,z,simT);
if(g>0.15){ctx.fillStyle=`rgba(10,40,90,${(g-0.15)*0.6})`;ctx.fillRect(i*W/n,j*H/n,W/n+1,H/n+1);}}
ctx.strokeStyle='rgba(120,230,200,.55)';ctx.lineWidth=1.2*k;
for(let z=-200;z<=-80;z+=30)for(let x=-140;x<=140;x+=56){const c=currentAt(x,z);if(c.x<0.3)continue;const[a,b]=P(x,z),L=c.x*10*k;
ctx.beginPath();ctx.moveTo(a-L,b);ctx.lineTo(a+L,b);ctx.lineTo(a+L-4,b-3);ctx.moveTo(a+L,b);ctx.lineTo(a+L-4,b+3);ctx.stroke();}
const[a,b]=P(LINE.x1,0),[c2,d2]=P(LINE.x2,0);
ctx.setLineDash([4,3]);ctx.strokeStyle='#fff';ctx.lineWidth=1.5*k;ctx.beginPath();ctx.moveTo(a,b);ctx.lineTo(c2,d2);ctx.stroke();ctx.setLineDash([]);
[[LINE.x1,0,'#ffb000'],[LINE.x2,0,'#fff'],[MARK.x,MARK.z,'#ff6a1a'],[LEE.x,LEE.z,'#ff6a1a']].forEach(([x,z,col])=>{const[p,q]=P(x,z);ctx.fillStyle=col;ctx.beginPath();ctx.arc(p,q,4*k,0,7);ctx.fill();});
ghosts.forEach(g=>{const[gx,gz]=P(g.x,g.z);ctx.save();ctx.translate(gx,gz);ctx.rotate(g.h*D2R);ctx.strokeStyle='#bfe3ff';ctx.lineWidth=1.3*k;
ctx.beginPath();ctx.moveTo(0,-5*k);ctx.lineTo(3*k,4*k);ctx.lineTo(-3*k,4*k);ctx.closePath();ctx.stroke();ctx.restore();});
fleet.slice().reverse().forEach(bt=>{const[bx,bz]=P(bt.x,bt.z);ctx.save();ctx.translate(bx,bz);ctx.rotate(bt.h*D2R);
ctx.fillStyle=bt.css;ctx.strokeStyle=bt.ai?'rgba(0,0,0,.4)':'#fff';ctx.lineWidth=k;const s=bt.ai?0.8:1.1;
ctx.beginPath();ctx.moveTo(0,-6*k*s);ctx.lineTo(3.6*k*s,4.5*k*s);ctx.lineTo(-3.6*k*s,4.5*k*s);ctx.closePath();ctx.fill();ctx.stroke();ctx.restore();});
const wd=windDirBase(simT)*D2R;ctx.save();ctx.translate(W-16*k,16*k);ctx.rotate(wd+Math.PI);ctx.strokeStyle='#fff';ctx.lineWidth=2*k;
ctx.beginPath();ctx.moveTo(0,-9*k);ctx.lineTo(0,9*k);ctx.moveTo(-4*k,4*k);ctx.lineTo(0,9*k);ctx.lineTo(4*k,4*k);ctx.stroke();ctx.restore();
ctx.fillStyle='rgba(244,247,246,.75)';ctx.font=`${10*k}px Atkinson Hyperlegible, sans-serif`;ctx.fillText('VENT',W-52*k,20*k);
}
function drawVane(){
const W=vaneC.width,H=vaneC.height,ctx=vctx,k=vaneC.dpr; ctx.clearRect(0,0,W,H);
const cx=W/2,cy=H*0.58,R=Math.min(W*0.4,H*0.38), rel=me.w?norm(me.w.dir-me.h):0;
ctx.fillStyle='rgba(255,90,60,.25)';ctx.beginPath();ctx.moveTo(cx,cy);const a=(rel-90)*D2R;ctx.arc(cx,cy,R,a-cls.min*D2R,a+cls.min*D2R);ctx.closePath();ctx.fill();
ctx.strokeStyle='rgba(255,255,255,.25)';ctx.lineWidth=k;ctx.beginPath();ctx.arc(cx,cy,R,0,7);ctx.stroke();
ctx.fillStyle='#f4f7f6';ctx.beginPath();ctx.moveTo(cx,cy-R*0.55);ctx.lineTo(cx+R*0.2,cy+R*0.45);ctx.lineTo(cx-R*0.2,cy+R*0.45);ctx.closePath();ctx.fill();
ctx.save();ctx.translate(cx,cy);ctx.rotate(rel*D2R);ctx.strokeStyle='#ffc53d';ctx.fillStyle='#ffc53d';ctx.lineWidth=3*k;
ctx.beginPath();ctx.moveTo(0,-R*1.02);ctx.lineTo(0,-R*0.62);ctx.stroke();ctx.beginPath();ctx.moveTo(0,-R*0.55);ctx.lineTo(-6*k,-R*0.72);ctx.lineTo(6*k,-R*0.72);ctx.closePath();ctx.fill();ctx.restore();
ctx.fillStyle='rgba(244,247,246,.8)';ctx.font=`${10*k}px Atkinson Hyperlegible, sans-serif`;ctx.fillText(Math.round(me.w?me.w.tws:15)+' nd',6*k,13*k);
ctx.textAlign='right';ctx.fillText(Math.round(me.twa)+'°',W-6*k,13*k);ctx.textAlign='left';
}
function fmt(s){s=Math.max(0,s);const m=Math.floor(s/60),r=Math.floor(s%60);return m+':'+String(r).padStart(2,'0');}
function poseBoat(b){
const m=b.m, fx=Math.sin(b.h*D2R), fz=-Math.cos(b.h*D2R), L=clsKey==='cat'?2.6:2, W=clsKey==='cat'?1.2:0.6;
const yb=waveY(b.x+fx*L,b.z+fz*L,simT), ys=waveY(b.x-fx*L,b.z-fz*L,simT), yr=waveY(b.x-fz*W,b.z+fx*W,simT), yl=waveY(b.x+fz*W,b.z-fx*W,simT);
const by=(yb+ys+yr+yl)/4, pitch=Math.atan2(yb-ys,2*L), roll=Math.atan2(yr-yl,2*W)*0.8;
m.group.position.set(b.x,by,b.z); m.group.rotation.order='YXZ';
m.group.rotation.set(pitch,-b.h*D2R,b.heel+roll);
updateHullWakes(b,frameDt);
if(b.m.main)boatSpray(b,yb,fx,fz,L);
const luff=(b.trim==='luff'||b.twa<cls.min)?Math.sin(simT*22+(b.seed||0))*0.09:0;
const boomA=Math.max(4,b.sheet*cls.boomMax)*D2R;
m.boomPivot.rotation.y=-b.side*boomA+luff;
const belly=(b.twa<cls.min||b.trim==='luff')?0.03:0.38*Math.min(1,b.eff);
shapeSail(m.main,belly,b.side);
if(m.jibPivot){m.jibPivot.rotation.y=-b.side*boomA*0.75+luff*0.6; shapeSail(m.jib,belly*0.8,b.side);}
const cs=b.cs===undefined?b.side:b.cs, s=cs>=0?1:-1, tf=b.tf||0, ld=b.load||0;
m.crew.forEach(c=>{
let th,x;
if(c.trap){th=(22+58*tf)*D2R; x=cs*c.edge*(0.5+0.5*tf);}
else{th=(18+42*ld)*D2R; x=cs*c.edge*0.95;}
c.g.position.set(x,c.deck,c.z); c.g.rotation.set(0,0,-s*th);
c.g.scale.y=c.trap?0.78+0.22*tf:0.8;
const on=c.trap&&tf>0.05; c.wire.visible=on;
if(on){const p=c.wire.geometry.attributes.position.array, L=1.0*c.g.scale.y;
p.set([m.mastTop[0],m.mastTop[1],m.mastTop[2], x+s*Math.sin(th)*L, c.deck+Math.cos(th)*L, c.z]); c.wire.geometry.attributes.position.needsUpdate=true;}
});
}
const camPos=new THREE.Vector3(0,8,40), tmpV=new THREE.Vector3(), look=new THREE.Vector3();
function placeCamera(dt){
const f=new THREE.Vector3(Math.sin(me.h*D2R),0,-Math.cos(me.h*D2R));
if(viewMode==='chase'){
const [back,up]=cls.cam;
tmpV.set(me.x,0,me.z).addScaledVector(f,-back).setY(up);
tmpV.y+=waveY(me.x,me.z,simT)*0.5;
camPos.lerp(tmpV,1-Math.exp(-dt*(state==='menu'?0.6:2.5)));
camera.position.copy(camPos);
look.set(me.x,1.2,me.z).addScaledVector(f,12);
camera.up.set(0,1,0); camera.lookAt(look);
} else {
me.m.group.updateMatrixWorld();
camera.position.copy(me.m.group.localToWorld(tmpV.set(...cls.fp)));
look.copy(me.m.group.localToWorld(new THREE.Vector3(cls.fp[0],cls.fp[1]-1.3,cls.fp[2]-10)));
camera.up.set(0,1,0).applyQuaternion(me.m.group.quaternion); camera.lookAt(look);
camPos.copy(camera.position);
}
}
let actx=null, master=null, noiseBuf=null, amb=null, soundOn=true;
function ensureAudio(){
try{
if(!actx){actx=new (window.AudioContext||window.webkitAudioContext)();master=actx.createGain();master.gain.value=soundOn?1:0;master.connect(actx.destination);
const len=actx.sampleRate*2;noiseBuf=actx.createBuffer(1,len,actx.sampleRate);const d=noiseBuf.getChannelData(0);
let b=0;for(let i=0;i<len;i++){const w=Math.random()*2-1;b=0.97*b+0.03*w;d[i]=w*0.6+b*3;}  // bruit un peu « rose »
startAmbient();}
if(actx.state==='suspended')actx.resume();
}catch(e){actx=null;}
}
function noiseVoice(type,f,q){
const s=actx.createBufferSource();s.buffer=noiseBuf;s.loop=true;s.playbackRate.value=0.85+Math.random()*0.3;
const fl=actx.createBiquadFilter();fl.type=type;fl.frequency.value=f;fl.Q.value=q;
const g=actx.createGain();g.gain.value=0;s.connect(fl);fl.connect(g);g.connect(master);s.start();return {fl,g};
}
function startAmbient(){
amb={wind:noiseVoice('bandpass',650,0.6),whistle:noiseVoice('bandpass',1900,10),sea:noiseVoice('lowpass',380,0.7),
surf:noiseVoice('bandpass',900,0.8),rush:noiseVoice('highpass',2600,0.5),flap:noiseVoice('bandpass',360,1.4)};
}
function audioUpdate(){
if(!amb)return;
const t=actx.currentTime, set=(n,v,k)=>n.g.gain.setTargetAtTime(v,t,k||0.15);
const w=me.w||{tws:15,g:0}, lvl=Math.min(1,Math.max(0,(w.tws-7)/10)), live=state==='menu'?0.5:1;
set(amb.wind,(0.05+0.13*lvl)*live); amb.wind.fl.frequency.setTargetAtTime(420+w.tws*28,t,0.4);
set(amb.whistle,Math.max(0,w.g-0.35)*0.06*live,0.4);
set(amb.sea,(0.07+0.05*(0.5+0.5*Math.sin(simT*0.9))+0.03*(0.5+0.5*Math.sin(simT*0.31+1)))*live,0.3);
const slap=Math.max(0,Math.sin(simT*1.9+Math.sin(simT*0.7)*2));                    // clapot sur la coque
set(amb.surf,(0.02+0.06*slap*slap*Math.min(1,me.v/5))*live,0.08);
set(amb.rush,Math.min(1,me.v/9)*0.08*live,0.3);
const luffing=state!=='menu'&&(me.trim==='luff'||me.twa<cls.min);
set(amb.flap,luffing?0.2*(Math.sin(simT*40)>0?1:0.15):0,0.015);                  // voile qui faseye
}
function tone(freqs,dur,type,vol,cut){
if(!actx)return; const t=actx.currentTime, g=actx.createGain(), f=actx.createBiquadFilter();
f.type='lowpass'; f.frequency.value=cut||4000; f.connect(g); g.connect(master);
g.gain.setValueAtTime(0,t); g.gain.linearRampToValueAtTime(vol,t+0.03); g.gain.setValueAtTime(vol,t+dur-0.12); g.gain.linearRampToValueAtTime(0,t+dur);
freqs.forEach(fr=>{const o=actx.createOscillator(); o.type=type; o.frequency.value=fr; o.connect(f); o.start(t); o.stop(t+dur+0.05);});
}
const beep=()=>tone([880],0.16,'sine',0.22);
const ding=()=>tone([1320],0.12,'triangle',0.12);
const horn=d=>tone([233,349,175],d,'sawtooth',0.12,1100);   // corne de brume du comité
function thump(vol){                                          // choc de coque
if(!actx)return; const t=actx.currentTime, v=vol||1;
const o=actx.createOscillator(),g=actx.createGain();o.type='sine';o.frequency.setValueAtTime(120,t);o.frequency.exponentialRampToValueAtTime(36,t+0.3);
g.gain.setValueAtTime(0.7*v,t);g.gain.exponentialRampToValueAtTime(0.001,t+0.45);o.connect(g);g.connect(master);o.start(t);o.stop(t+0.5);
const s=actx.createBufferSource();s.buffer=noiseBuf;const f=actx.createBiquadFilter();f.type='lowpass';f.frequency.value=1400;
const g2=actx.createGain();g2.gain.setValueAtTime(0.5*v,t);g2.gain.exponentialRampToValueAtTime(0.001,t+0.18);
s.connect(f);f.connect(g2);g2.connect(master);s.start(t,Math.random(),0.25);
}
$('sound').onclick=()=>{soundOn=!soundOn;$('sound').textContent='SON : '+(soundOn?'OUI':'NON');ensureAudio();if(master)master.gain.value=soundOn?1:0;if(soundOn)ding();};
const GAME_URL='https://www.navibreizhshop.bzh/pages/jeu-de-regate';
(function(){
const st=document.createElement('style');
st.textContent='.share{margin:14px 0 4px;padding-top:12px;border-top:1px solid rgba(255,255,255,.14)}.share .row{display:flex;flex-wrap:wrap;gap:6px;margin-top:6px}.share button{flex:1 1 auto;min-width:88px;padding:9px 10px;border:1px solid rgba(255,255,255,.3);border-radius:8px;background:rgba(255,255,255,.06);color:var(--foam);font:700 13px var(--f-body);cursor:pointer}.share button.main{background:var(--foam);color:var(--navy);border-color:var(--foam)}.share button:focus-visible{outline:3px solid var(--warn);outline-offset:2px}.share img{display:block;width:100%;max-width:220px;margin:8px auto 4px;border-radius:10px;border:1px solid rgba(255,255,255,.18)}a.cta.shop{margin-top:10px;text-align:center;text-decoration:none;box-sizing:border-box;font-size:20px}.mail{margin-top:12px}.mailrow{display:flex;gap:6px;margin-top:4px}.mailrow input{flex:1;min-width:0;padding:10px 12px;border-radius:8px;border:1px solid rgba(255,255,255,.3);background:rgba(255,255,255,.06);color:var(--foam);font:15px var(--f-body);-webkit-user-select:text;user-select:text}.mailrow button{padding:10px 14px;border:0;border-radius:8px;background:var(--foam);color:var(--navy);font:700 14px var(--f-body);cursor:pointer}.mailrow button:disabled{opacity:.6}.optin{display:flex;gap:8px;align-items:flex-start;margin-top:8px;font-size:12.5px;line-height:1.4;cursor:pointer}.optin input{margin-top:2px;flex:none;width:18px;height:18px;accent-color:#ff6a1a}.mailrow input:focus-visible,.mailrow button:focus-visible{outline:3px solid var(--warn);outline-offset:1px}';
document.head.appendChild(st);
})();
function resultImage(o){
const c=document.createElement('canvas'); c.width=1080; c.height=1350; const x=c.getContext('2d');
const g=x.createLinearGradient(0,0,0,1350); g.addColorStop(0,'#0b2540'); g.addColorStop(1,'#0d4a66'); x.fillStyle=g; x.fillRect(0,0,1080,1350);
x.fillStyle='rgba(255,255,255,.06)'; for(let i=0;i<6;i++){x.beginPath();x.ellipse(540,1250+i*40,900,60,0,0,7);x.fill();}
const F='"Big Shoulders Display", Impact, sans-serif', B='"Atkinson Hyperlegible", sans-serif';
if(LOGO.complete&&LOGO.naturalWidth){const h=150,w=h*LOGO.naturalWidth/LOGO.naturalHeight; x.drawImage(LOGO,80,70,w,h);}
x.fillStyle='#a9c3d1'; x.font='700 30px '+B; x.textAlign='right'; x.fillText('NAVIBREIZHSHOP',1000,110);
x.fillStyle='#f4f7f6'; x.font='800 96px '+F; x.fillText('Régate',1000,200); x.fillStyle='#ff6a1a'; x.fillText('express',1000,290);
x.textAlign='left'; x.fillStyle='#a9c3d1'; x.font='700 32px '+B; x.fillText(o.eyebrow.toUpperCase(),80,390);
x.fillStyle='#f4f7f6'; x.font='800 190px '+F; x.fillText(o.big,74,560);
if(o.sub){x.fillStyle='#a9c3d1'; x.font='400 36px '+B; x.fillText(o.sub,80,645);}
let y=715; x.fillStyle='#a9c3d1'; x.font='700 28px '+B; x.fillText((o.boardTitle||'CLASSEMENT').toUpperCase(),80,y); y+=24;
(o.rows||[]).slice(0,6).forEach(r=>{
y+=68; if(r.mine){x.fillStyle='rgba(255,106,26,.18)'; x.fillRect(60,y-52,960,66);}
x.fillStyle=r.mine?'#ff6a1a':'#f4f7f6'; x.font='800 50px '+F; x.fillText(String(r.rank),90,y);
x.font=(r.mine?'700 ':'400 ')+'40px '+B; x.fillText(String(r.name).slice(0,18),190,y);
x.textAlign='right'; x.font='800 50px '+F; x.fillText(r.val,990,y); x.textAlign='left';
});
x.fillStyle='#ff6a1a'; x.fillRect(80,1180,920,4);
x.fillStyle='#f4f7f6'; x.font='700 40px '+B; x.fillText('À vous de jouer !',80,1250);
x.fillStyle='#a9c3d1'; x.font='400 32px '+B; x.fillText('navibreizhshop.bzh/pages/jeu-de-regate',80,1300);
return c;
}
let shareFile=null, shareUrl=null;
function shareBlock(){
const native=!!navigator.share;
return `<div class="share"><p class="eyebrow" style="margin:0">Partager mon score</p>
<img id="shareImg" alt="Aperçu de l’image partagée : votre résultat et le classement" hidden>
<div class="row">
${native?'<button class="main" data-sh="native">Partager…</button>':''}
<button data-sh="fb">Facebook</button><button data-sh="x">X</button><button data-sh="wa">WhatsApp</button><button data-sh="li">LinkedIn</button>
<button data-sh="copy">Copier le lien</button><button data-sh="img">Télécharger l’image</button></div></div>`;
}
function bindShare(text,img){
const full=text+' '+GAME_URL, u=encodeURIComponent(GAME_URL), t=encodeURIComponent(text);
shareFile=null; if(shareUrl){URL.revokeObjectURL(shareUrl);shareUrl=null;}
if(img){try{resultImage(img).toBlob(b=>{if(!b)return;shareFile=new File([b],'regate-navibreizhshop.png',{type:'image/png'});shareUrl=URL.createObjectURL(b);
const im=$('shareImg'); if(im){im.src=shareUrl;im.hidden=false;}},'image/png');}catch(e){}}
const urls={fb:'https://www.facebook.com/sharer/sharer.php?u='+u, x:'https://twitter.com/intent/tweet?text='+t+'&url='+u,
wa:'https://wa.me/?text='+encodeURIComponent(full), li:'https://www.linkedin.com/sharing/share-offsite/?url='+u};
document.querySelectorAll('.share [data-sh]').forEach(b=>b.onclick=()=>{
const k=b.dataset.sh;
if(k==='native'){
const d={title:'Régate express · Navibreizhshop',text:full};
if(shareFile&&navigator.canShare&&navigator.canShare({files:[shareFile]}))d.files=[shareFile]; else d.url=GAME_URL;
navigator.share(d).catch(()=>{});return;}
if(k==='img'){if(!shareUrl)return;const a=document.createElement('a');a.href=shareUrl;a.download='regate-navibreizhshop.png';document.body.appendChild(a);a.click();a.remove();return;}
if(k==='copy'){try{navigator.clipboard.writeText(full).then(()=>{b.textContent='Lien copié';},()=>{});}catch(e){}return;}
window.open(urls[k],'_blank','noopener,width=620,height=560');
});
}
let paused=false;
(function(){
const st=document.createElement('style');
st.textContent='#pause{position:fixed;bottom:calc(env(safe-area-inset-bottom,0px) + 238px);left:max(16px,env(safe-area-inset-left,0px));padding:8px 12px;border:1px solid rgba(255,255,255,.3);color:var(--foam);font:700 12px var(--f-body);letter-spacing:.06em;cursor:pointer}#pause:focus-visible{outline:3px solid var(--warn)}@media (max-width:520px){#pause{bottom:calc(env(safe-area-inset-bottom,0px) + 280px)}#hint{bottom:calc(env(safe-area-inset-bottom,0px) + 326px)!important}}';
document.head.appendChild(st);
const b=document.createElement('button'); b.id='pause'; b.className='panel'; b.hidden=true; b.textContent='❚❚ PAUSE';
b.setAttribute('aria-label','Mettre le jeu en pause (touche P)'); $('fs').after(b);
})();
function canPause(){return state==='count'||state==='race'||state==='arcade';}
function pauseGame(){
if(paused||!canPause())return; paused=true; for(const k in keys)keys[k]=false;
if(master)master.gain.value=0; if(mode==='arcade')musicStop();
$('card').innerHTML=`<p class="eyebrow">Pause</p><h1>Jeu en <em>pause</em></h1>
<p>Le chrono est arrêté. Reprenez quand vous voulez.</p>
<button class="cta" id="resume" style="margin-top:12px">Reprendre</button>
<button class="ghost" id="quit">Abandonner et revenir au menu</button>`;
$('overlay').hidden=false; $('resume').focus();
$('resume').onclick=resumeGame; $('quit').onclick=()=>{paused=false;if(master)master.gain.value=soundOn?1:0;menu();};
}
function resumeGame(){
if(!paused)return; paused=false; $('overlay').hidden=true; last=performance.now();
if(master)master.gain.value=soundOn?1:0; if(mode==='arcade'&&state==='arcade')musicStart();
}
$('pause').onclick=()=>paused?resumeGame():pauseGame();
addEventListener('keydown',e=>{if(e.target&&e.target.id==='pseudo')return;if(e.key==='p'||e.key==='P'||e.key==='Escape'){e.preventDefault();paused?resumeGame():pauseGame();}});
document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseGame();});
let last=performance.now(), penalty=0, frameDt=0.016;
function frame(now){
if(paused){last=now;requestAnimationFrame(frame);return;}
const dt=Math.min(0.05,(now-last)/1000); last=now; simT+=dt; frameDt=dt;
$('pause').hidden=!(state==='count'||state==='race'||state==='arcade');
if(mode==='arcade'){arcadeFrame(dt);if(msgTimer>0){msgTimer-=dt;if(msgTimer<=0)$('msg').style.opacity=0;}requestAnimationFrame(frame);return;}
if(state==='count'){count-=dt;const n=Math.ceil(count);
if(n!==lastN){lastN=n;
if(n===10){horn(0.6);flash('10 secondes !',0.9);}
else if(n<10&&n>0){beep();flash(String(n),0.9);}}
if(count<=0){state='race';t0=simT;horn(1.5);
fleet.forEach(b=>{if(b.z<LINE.z){b.ocs=true;if(!b.ai)flash('Départ anticipé ! Repassez sous la ligne',2.5);}});
if(!me.ocs)flash('Partez !',1);}}
const racing=state==='race'||state==='done'||state==='count';
fleet.forEach(b=>stepBoat(b,dt,racing&&!(b===me&&state==='done')));
if(racing){rightOfWay();separate();if(state!=='count')fleet.forEach(rules);}
water.position.set(Math.round(me.x/WSTEP)*WSTEP,0,Math.round(me.z/WSTEP)*WSTEP);
waterFar.position.x=water.position.x; waterFar.position.z=water.position.z;
water.material.uniforms.uT.value=waterFar.material.uniforms.uT.value=simT;
if(mode==='ghost'){
ghosts.forEach(g=>{updateGhost(g,state==='count'?0:simT-t0);poseBoat(g);});
if(state==='race'&&!me.finish){recT-=dt;if(recT<=0){recT+=GSTEP;
rec.push(Math.round(me.x*10),Math.round(me.z*10),Math.round(me.h),Math.round(me.heel*100),me.side,Math.round(me.sheet*100),me.phase);}}
}
fleet.forEach(poseBoat); updateRibs(dt); updateGulls(); updateSpray(dt);
[markObj,leeObj,pinObj].forEach(b=>{b.position.y=waveY(b.position.x,b.position.z,simT)*0.8;b.userData.flag.rotation.y=Math.sin(simT*3)*0.2;});
comm.position.y=waveY(comm.position.x,comm.position.z,simT)*0.6;
placeCamera(dt);
sky.position.copy(camera.position); clouds.position.set(camera.position.x,0,camera.position.z); clouds.rotation.y=simT*0.002;
renderer.render(scene,camera);
audioUpdate(dt);
$('tChrono').textContent=state==='count'?'-'+fmt(Math.ceil(count)):fmt(state==='race'?simT-t0+penalty:me.finish||0);
$('tSpeed').textContent=me.v.toFixed(1);
$('tPos').innerHTML=(state==='menu'||state==='count')?'–':mode==='ghost'?`${rankGhost()}<small>/${ghosts.length+fleet.length}</small>`:`${rankOf(me)}<small>/${fleet.length}</small>`;
const pct=Math.round(me.eff*100), ng=me.twa<cls.min;
$('tTrim').textContent=ng?'—':pct+'%';
const tf=$('trimfill');tf.style.width=(ng?0:pct)+'%';tf.style.background=pct>85?'#3ccf8e':pct>55?'#ffc53d':'#ff6a1a';
const sk=$('sknob');sk.style.top=(me.sheet*(sheetEl.clientHeight-48))+'px';sk.textContent=Math.round(me.sheet*100)+'%';
const lap=me.phase<2?1:2;
const tgt=state==='count'||me.ocs?{x:0,z:LINE.z,l:me.ocs?'Repassez sous la ligne':'Ligne de départ'}:me.phase===1?{x:LEE.x,z:LEE.z,l:'Bouée sous le vent'}:me.phase>=3?{x:0,z:LINE.z,l:'Ligne d’arrivée'}:{x:MARK.x,z:MARK.z,l:'Bouée au vent'};
if(state!=='count'&&!me.ocs)tgt.l='Tour '+lap+'/2 · '+tgt.l;
const brg=Math.atan2(tgt.x-me.x,-(tgt.z-me.z))*R2D;
$('tarrow').style.transform=`rotate(${norm(brg-me.h)}deg)`;
$('tlabel').firstChild.nodeValue=tgt.l+' · ';$('tdist').textContent=Math.round(Math.hypot(tgt.x-me.x,tgt.z-me.z));
if(state==='count'&&me.z<LINE.z)hint('Vous êtes au-dessus de la ligne : redescendez !','#ff8a5c');
else if(state==='race'||state==='count'){
if(meWarn&&meWarn.dist<35)hint(meWarn.port?`${meWarn.o.name} est tribord amures : écartez-vous !`:meWarn.astern?`Vous rattrapez ${meWarn.o.name} : écartez-vous !`:`Vous êtes au vent de ${meWarn.o.name} : écartez-vous !`,'#ff8a5c');
else if(ng)hint('Vent debout : abattez !','#ff8a5c');
else if(me.trim==='luff')hint('La voile faseye : bordez','#ffc53d');
else if(me.trim==='tight')hint('Trop bordé : choquez','#ffc53d');
else if(me.w.g>0.55)hint('Risée : ça accélère !','#3ccf8e');
else hint('');
} else hint('');
if(msgTimer>0){msgTimer-=dt;if(msgTimer<=0)$('msg').style.opacity=0;}
drawMap(); drawVane();
requestAnimationFrame(frame);
}
const GHOST_T0=600, GSTEP=0.5, GF=7;          // GF : valeurs par point [x,z,cap,gîte,amures,écoute,étape]
let mode='champ', ghosts=[], rec=[], recT=0, db=null, uid=null, lbState='loading', sb=null;
const lbDocs={dinghy:[],cat:[]};
function loadPseudo(){try{return localStorage.getItem('regate.pseudo')||'';}catch(e){return '';}}
function savePseudo(v){try{localStorage.setItem('regate.pseudo',v);}catch(e){}}
const SB_URL='https://tiuucevkqticemrcpbnm.supabase.co', SB_KEY='sb_publishable_tg_5l7o4yCXlVYDT_9hM_Q_WFutOp1T';
async function loadLB(){
if(!sb)return;
try{
const res=await Promise.all(['dinghy','cat'].map(k=>sb.from('leaderboard').select('user_id,pseudo,race_time,track').eq('cls',k).order('race_time',{ascending:true}).limit(10)));
res.forEach((r,i)=>{if(r.error)throw r.error;lbDocs[i?'cat':'dinghy']=(r.data||[]).map(d=>({id:d.user_id,pseudo:d.pseudo,time:d.race_time,track:d.track}));});
lbState='ok';
}catch(e){lbState='off';}
renderLB(); arcadeLoad();
}
(async()=>{
try{
if(!window.supabase){lbState='off';renderLB();return;}
sb=window.supabase.createClient(SB_URL,SB_KEY); db=sb;
const {data}=await sb.auth.getSession(); uid=data&&data.session?data.session.user.id:null;
const t=setTimeout(()=>{if(lbState==='loading'){lbState='slow';renderLB();}},10000);
await loadLB(); clearTimeout(t);
}catch(e){lbState='off';renderLB();}
})();
function renderLB(){
try{if(lbState==='off'&&lbArcadeState==='loading'){lbArcadeState='off';renderArcadeLB();}}catch(e){}
const el=$('lb'); if(!el)return;
const list=lbDocs[clsKey]||[];
if(lbState==='off'){el.innerHTML='<p class="keys">Classement en ligne momentanément indisponible.</p>';return;}
if(lbState==='loading'){el.innerHTML='<p class="keys">Chargement du classement…</p>';return;}
const board=(k,max)=>{const l=(lbDocs[k]||[]).slice(0,max);
if(!l.length){const p=document.createElement('p');p.className='keys';p.textContent=(lbState==='slow'?'Le classement ne répond pas encore. ':'')+'Aucun temps en '+CLASSES[k].name.toLowerCase()+' pour l’instant : soyez le premier !';return p;}
const box=document.createElement('div');box.className='board';
l.forEach((d,i)=>{const mine=d.id===uid;
[String(i+1),String(d.pseudo||'Anonyme').slice(0,16),fmt(d.time)].forEach(t=>{const s=document.createElement('span');s.textContent=t;if(mine)s.className='me';box.appendChild(s);});});
return box;};
el.innerHTML='';
if(el.dataset.both){                       // accueil : les deux classements, dériveur et catamaran
['dinghy','cat'].forEach(k=>{const h=document.createElement('p');h.className='eyebrow';h.style.margin='10px 0 2px';h.textContent='Meilleurs temps · '+CLASSES[k].name;el.appendChild(h);el.appendChild(board(k,5));});
} else el.appendChild(board(clsKey,10));
}
function nameSprite(text){
const c=document.createElement('canvas');c.width=256;c.height=64;const x=c.getContext('2d');
x.fillStyle='rgba(11,37,64,.75)';x.beginPath();x.roundRect?x.roundRect(8,8,240,48,16):x.rect(8,8,240,48);x.fill();
x.fillStyle='#f4f7f6';x.font='700 28px "Atkinson Hyperlegible", sans-serif';x.textAlign='center';x.textBaseline='middle';x.fillText(text,128,33);
const sp=new THREE.Sprite(new THREE.SpriteMaterial({map:new THREE.CanvasTexture(c),depthTest:false,transparent:true}));
sp.scale.set(5,1.25,1);return sp;
}
function clearGhosts(){ghosts.forEach(g=>{scene.remove(g.m.group);scene.remove(g.m.wake);});ghosts=[];}
function makeGhost(d){
const m=makeBoat(clsKey,{base:'#ffffff',css:'#7cc4ff',accent:0x7cc4ff,num:'',brand:''});
m.group.traverse(o=>{if(!o.isMesh)return;
if(o.material.type==='ShaderMaterial'){o.visible=false;return;}
o.material=o.material.clone();o.material.transparent=true;o.material.opacity=0.42;o.material.depthWrite=false;});
const sp=nameSprite((d.id===uid?'Votre record':String(d.pseudo||'Anonyme').slice(0,16))+' · '+fmt(d.time));
sp.position.y=clsKey==='cat'?10.5:8; m.group.add(sp);
const tr=d.track||[];
return {m,doc:d,track:tr,n:Math.floor(tr.length/GF),name:d.pseudo,time:d.time,x:0,z:0,h:0,heel:0,side:1,sheet:0.4,phase:0,v:0,twa:90,trim:'ok',eff:1,tf:0,load:0,seed:Math.random()*9};
}
function sampleGhost(g,i){const k=Math.max(0,Math.min(g.n-1,i))*GF,t=g.track;return [t[k]/10,t[k+1]/10,t[k+2],t[k+3]/100,t[k+4],t[k+5]/100,t[k+6]];}
function updateGhost(g,t){
if(!g.n)return;
const f=Math.max(0,t)/GSTEP, i=Math.floor(f), a=f-i, A=sampleGhost(g,i), B=sampleGhost(g,i+1);
const px=g.x,pz=g.z;
g.x=A[0]+(B[0]-A[0])*a; g.z=A[1]+(B[1]-A[1])*a; g.h=(A[2]+norm(B[2]-A[2])*a+360)%360;
g.heel=A[3]+(B[3]-A[3])*a; g.side=A[4]; g.cs=A[4]; g.sheet=A[5]; g.phase=A[6];
g.v=t>0&&i<g.n-1?Math.hypot(g.x-px,g.z-pz)/Math.max(frameDt,1e-3)/KN:0;
g.finished=t>=g.time; g.tf=Math.min(1,Math.abs(g.heel)/cls.heelMax*1.6); g.load=g.tf;
g.w=me.w; g.twa=90;
}
function progressGhost(g){
if(g.finished)return 1e6-g.time;
const t=g.phase===1?{x:LEE.x-7,z:LEE.z+8}:g.phase>=3?{x:0,z:LINE.z+6}:{x:MARK.x+7,z:MARK.z-8};
return g.phase*1000-Math.hypot(t.x-g.x,t.z-g.z);
}
function rankGhost(){const p=progress(me);return 1+ghosts.filter(g=>progressGhost(g)>p).length+fleet.filter(b=>b!==me&&progress(b)>p).length;}
function startGhost(){
mode='ghost'; clearGhosts();
ghosts=(lbDocs[clsKey]||[]).slice(0,5).map(makeGhost).filter(g=>g.n>1);
const nAI=Math.max(2,5-ghosts.length); series={race:2,results:[]}; buildFleet(true);
fleet.filter(b=>b.ai).forEach((b,i)=>{if(i>=nAI){scene.remove(b.m.group);scene.remove(b.m.wake);b.drop=true;return;}
const sp=nameSprite(b.name+' · ordinateur'); sp.position.y=clsKey==='cat'?10.5:8; b.m.group.add(sp);});
fleet=fleet.filter(b=>!b.drop);
penalty=0; bumps={}; pairMem={}; lastN=null; rec=[]; recT=0;
simT=GHOST_T0-40.4; camPos.set(me.x,cls.cam[1],me.z+cls.cam[0]);
ensureAudio(); $('overlay').hidden=true; state='count'; count=40.4; horn(0.8);
flash(ghosts.length?`Contre-la-montre · ${ghosts.length} fantôme${ghosts.length>1?'s':''} · 30 s pour vous placer`:'Contre-la-montre · 30 s pour vous placer',2.5);
}
async function endGhost(){
state='done'; horn(0.7);
const tot=me.finish, pseudo=(loadPseudo()||'Anonyme').slice(0,16);
const lbList=lbState==='ok'?(lbDocs[clsKey]||[]):[], top=lbList[0]||null;
const record=!!top&&tot<top.time&&!(top.id===uid&&lbList.length<2);   // record battu (un autre joueur doit figurer au classement)
let note='', saved=false;
if(sb){
try{
let {data}=await sb.auth.getSession(), session=data&&data.session;
if(!session){const r=await sb.auth.signInAnonymously();if(r.error)throw r.error;session=r.data.session;}
uid=session.user.id;
const cur=await sb.from('leaderboard').select('race_time').eq('user_id',uid).eq('cls',clsKey).maybeSingle();
if(cur.error)throw cur.error;
const prev=cur.data?cur.data.race_time:null;
if(prev===null||tot<prev){
const up=await sb.from('leaderboard').upsert({user_id:uid,cls:clsKey,pseudo,race_time:Math.round(tot*100)/100,track:rec,updated_at:new Date().toISOString()});
if(up.error)throw up.error; saved=true;
note=prev===null?'Premier temps enregistré au classement.':`Nouveau record personnel ! (ancien : ${fmt(prev)})`;
} else note=`Votre record reste ${fmt(prev)}.`;
loadLB();
}catch(e){note='Temps non enregistré : le classement en ligne ne répond pas. Réessayez plus tard.';}
} else note='Classement en ligne indisponible : temps non enregistré.';
const beaten=ghosts.filter(g=>tot<g.time).length;
$('card').innerHTML=`<p class="eyebrow">${CLASSES[clsKey].name} · contre-la-montre</p>
<div class="big">${fmt(tot)}</div>
<p class="keys">${penalty?`Dont ${penalty} s de pénalité · `:''}${ghosts.length?`${beaten} fantôme${beaten>1?'s':''} battu${beaten>1?'s':''} sur ${ghosts.length}`:'Aucun fantôme à battre'}</p>
<p>${note}</p>
${record&&saved?`<p>Record battu (ancien : ${fmt(top.time)}) ! Vous gagnez <b>10 % de réduction</b> sur une commande en ligne Navibreizhshop.</p>${REWARD_WAIT}`
:top?`<p class="keys">Battez le record (${fmt(top.time)}) pour gagner 10 % de réduction sur une commande en ligne.</p>`:''}
<p class="eyebrow" style="margin-top:12px">Meilleurs temps · ${CLASSES[clsKey].name}</p>
<div id="lb"></div>${shareBlock()}
<button class="cta" id="go" style="margin-top:12px">Rejouer</button>
<button class="ghost" id="menu">Menu</button>`;
renderLB(); $('overlay').hidden=false; $('go').onclick=startGhost; $('menu').onclick=menu;
{const old=(lbDocs[clsKey]||[]).find(d=>d.id===uid), best=old?Math.min(old.time,tot):tot;
const lb=(lbDocs[clsKey]||[]).filter(d=>d.id!==uid).concat([{id:uid,pseudo,time:best}]).sort((a,b)=>a.time-b.time);
const rows=lb.slice(0,5).map((d,i)=>({rank:i+1,name:d.pseudo||'Anonyme',val:fmt(d.time),mine:d.id===uid}));
if(!rows.some(r=>r.mine)){const i=lb.findIndex(d=>d.id===uid);rows.push({rank:i+1,name:pseudo,val:fmt(best),mine:true});}
bindShare(`J’ai bouclé le contre-la-montre Régate express de Navibreizhshop en ${fmt(tot)} (${CLASSES[clsKey].name.toLowerCase()})${record&&saved?' et battu le record':''} ! Battez mon temps :`,
{eyebrow:'Contre-la-montre · '+CLASSES[clsKey].name,big:fmt(tot),sub:record&&saved?'Nouveau record !':(penalty?'dont '+penalty+' s de pénalité':'sans pénalité'),boardTitle:'Meilleurs temps',rows});}
if(record&&saved)fillReward('ghost',clsKey);
}
const SHOP_URL='https://www.navibreizhshop.bzh';
function codeBlock(code){return `<div class="code"><span id="code">${code}</span><button class="btn" id="cp" style="width:auto;height:auto;border-radius:8px;padding:6px 10px;font-size:13px">Copier</button></div>
<p class="keys">Code unique valable sur une commande en ligne, appliqué sur le total de la commande, utilisable une seule fois, non cumulable avec une autre réduction.</p>
<a class="cta shop" href="${SHOP_URL}/discount/${encodeURIComponent(code)}?redirect=%2Fcollections%2Fall" target="_blank" rel="noopener">Profiter de ma réduction sur la boutique</a>
<p class="keys" style="margin-top:4px">La réduction est appliquée automatiquement à votre panier.</p>
<form class="mail" id="mailForm" novalidate>
<label class="keys" for="mail" style="color:var(--foam);font-weight:700">Newsletter Navibreizhshop : nouveautés, offres et prochains défis</label>
<div class="mailrow"><input id="mail" type="email" autocomplete="email" inputmode="email" placeholder="vous@exemple.fr" required>
<button type="submit" id="mailGo">S’inscrire</button></div>
<label class="keys optin"><input type="checkbox" id="optin"> J’accepte de recevoir les e-mails de Navibreizhshop. Désinscription possible à tout moment depuis chaque e-mail.</label>
<p class="keys" id="mailMsg" style="margin:6px 0 0"></p>
</form>`;}
const REWARD_WAIT='<div class="reward" id="reward"><p class="keys">Préparation de votre code de réduction unique…</p></div>';
const REWARD_MSG={
LIMIT:'Vous avez déjà gagné un code de réduction dans les dernières 24 heures : rejouez demain pour en gagner un autre.',
NOREC:'Votre record n’a pas pu être confirmé par le classement en ligne, aucun code n’a été délivré.',
ERR:`Votre code n’a pas pu être délivré automatiquement. Appelez la boutique au ${SHOP_PHONE} en indiquant votre pseudo et l’heure de votre victoire.`
};
async function claimReward(mode,cls){
if(!sb)return {code:'DEMO-REGATE',demo:true};
let {data}=await sb.auth.getSession(), session=data&&data.session;
if(!session){const r=await sb.auth.signInAnonymously();if(r.error)throw r.error;session=r.data.session;}
uid=session.user.id;
const r=await sb.rpc('claim_reward',{p_mode:mode,p_cls:cls||null});
if(r.error)throw r.error;
if(typeof r.data==='string'&&/^REGATE-/.test(r.data))return {code:r.data};
return {msg:REWARD_MSG[r.data]||REWARD_MSG.ERR};
}
async function fillReward(mode,cls){
let r; try{r=await claimReward(mode,cls);}catch(e){r={msg:REWARD_MSG.ERR};}
const el=$('reward'); if(!el)return;
if(r.code){el.innerHTML=codeBlock(r.code)+(r.demo?'<p class="demo">Code de démonstration : sur le site, chaque gagnant reçoit un code unique.</p>':'');bindCopy();bindMail();}
else{const p=document.createElement('p');p.className='keys';p.textContent=r.msg;el.innerHTML='';el.appendChild(p);}
}
function bindMail(){
const f=$('mailForm'); if(!f)return;
const inp=$('mail'), btn=$('mailGo'), msg=$('mailMsg'), opt=$('optin');
inp.addEventListener('keydown',e=>e.stopPropagation());
f.onsubmit=async e=>{
e.preventDefault();
const email=inp.value.trim();
if(!/^[^@ ]+@[^@ ]+[.][^@ ]+$/.test(email)){msg.textContent='Adresse e-mail invalide : vérifiez-la.';inp.focus();return;}
if(!opt.checked){msg.textContent='Cochez la case pour accepter de recevoir nos e-mails.';opt.focus();return;}
const onShop=/navibreizhshop|myshopify/.test(location.hostname);
if(!onShop){msg.textContent='Démonstration : sur le site, l’adresse est inscrite à la newsletter de la boutique.';return;}
btn.disabled=true; btn.textContent='Envoi…';
const fields={form_type:'customer',utf8:'✓','contact[email]':email,'contact[tags]':'newsletter,jeu-regate'};
try{
const r=await fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:new URLSearchParams(fields),credentials:'same-origin'});
if(/challenge/.test(r.url)){                        // la boutique demande une vérification anti-robot : on ouvre le formulaire dans un onglet
const fm=document.createElement('form');fm.method='POST';fm.action='/contact';fm.target='_blank';
Object.entries(fields).forEach(([k,v])=>{const i=document.createElement('input');i.type='hidden';i.name=k;i.value=v;fm.appendChild(i);});
document.body.appendChild(fm);fm.submit();fm.remove();
msg.textContent='Une vérification s’ouvre dans un nouvel onglet : validez-la pour terminer l’inscription.';btn.textContent='S’inscrire';btn.disabled=false;return;}
if(!r.ok)throw new Error(r.status);
msg.textContent='Merci ! '+email+' est inscrit à la newsletter Navibreizhshop.';btn.textContent='Inscrit';inp.disabled=true;opt.disabled=true;
}catch(_){msg.textContent='L’inscription n’a pas fonctionné. Réessayez dans un instant.';btn.textContent='S’inscrire';btn.disabled=false;}
};
}
function bindCopy(){const cp=$('cp'); if(cp)cp.onclick=()=>{const t=$('code').textContent;try{navigator.clipboard.writeText(t).then(()=>cp.textContent='Copié',()=>{});}catch(e){}};}
const AR={W:360,LEVELS:10};
const arc=$('arcade'), actxA=arc.getContext('2d');
let A=null, lbArcade=[], lbArcadeState='loading', arcadeSub=false;
const ARC_COLS=['#e85d75','#4fa3e0','#f2c14e','#7bc47f','#b388eb','#f08a4b','#5ec2c2'];
function arcSize(){const d=Math.min(devicePixelRatio,2);arc.width=Math.round(innerWidth*d);arc.height=Math.round(innerHeight*d);}
function arcLevel(L){return {speed:150+L*20,len:3000+L*300,gap:Math.max(0.42,1.45-0.11*L),oncoming:0.12+0.05*L,bands:Math.max(1,2.6-0.15*L)};}
const better=(a,b)=>!b||a.points<b.points||(a.points===b.points&&a.time<b.time);
function startArcade(){
mode='arcade'; state='arcade'; clearGhosts();
document.body.classList.add('arcade-on'); arc.hidden=false; arcSize();
A={t:0,lvl:1,dist:0,lvlStart:0,x:AR.W/2,vx:0,speed:0,mult:1,eff:'',points:0,inv:0,boats:[],bands:[],spawnT:1.6,bandT:0.6,
done:false,shake:0,targetX:null,start:3.4,lastN:null,camX:0,sway:1};
ensureAudio(); musicStop(); $('overlay').hidden=true; flash('Arcade · niveau 1',1.6);
}
function arcStep(dt,v){
const P=arcLevel(A.lvl);
if(A.start>0){A.start-=dt;const n=Math.ceil(A.start);
if(n!==A.lastN){A.lastN=n;if(n>0){beep();flash(String(n),0.8);}else{horn(1);flash('Partez !',0.8);musicStart();}}return;}
if(A.done)return;
A.t+=dt;
let inp=me.rIn; if(keys.ArrowLeft||keys.a||keys.q)inp=-1; if(keys.ArrowRight||keys.d)inp=1;
if(!inp&&A.targetX!=null)inp=Math.max(-1,Math.min(1,(A.targetX-A.x)/22));
A.vx+=(inp*230-A.vx)*Math.min(1,dt*9); A.x=Math.max(14,Math.min(AR.W-14,A.x+A.vx*dt));
let m=1;A.eff='';
for(const b of A.bands)if(A.dist>b.d0&&A.dist<b.d1&&A.x>b.x0&&A.x<b.x1){m=b.type==='gust'?1.45:0.55;A.eff=b.type;}
A.mult+=(m-A.mult)*Math.min(1,dt*3); A.speed=P.speed*A.mult; A.dist+=A.speed*dt;
A.spawnT-=dt; if(A.spawnT<=0){A.spawnT=P.gap*(0.6+Math.random()*0.8);spawnBoat(P);}
A.bandT-=dt; if(A.bandT<=0){A.bandT=P.bands*(0.6+Math.random()*0.8);spawnBand();}
for(const o of A.boats){o.d+=o.v*o.dir*dt;o.ph+=dt;o.x=Math.max(12,Math.min(AR.W-12,o.x+Math.sin(o.ph*o.wf)*o.wa*dt));}
A.boats=A.boats.filter(o=>o.d>A.dist-CAMBACK);
A.bands=A.bands.filter(b=>b.d1>A.dist-CAMBACK);
if(A.inv>0)A.inv-=dt;
else for(const o of A.boats)if(Math.abs(o.x-A.x)<13&&Math.abs(o.d-A.dist)<30){
A.points++;A.inv=1.3;A.shake=0.35;A.mult=0.35;o.x+=o.x<A.x?-14:14;thump(1);flash('Choc ! +1 point',1);break;}
if(A.shake>0)A.shake-=dt;
if(A.dist>=A.lvlStart+P.len){ding();
if(A.lvl>=AR.LEVELS){A.done=true;endArcade();}
else{A.lvl++;A.lvlStart=A.dist;musicTempo(A.lvl);flash('Niveau '+A.lvl+' · plus vite !',1.5);}}
}
const AHEAD=1300, CAMBACK=135;
function arcView(){
const W=arc.width,H=arc.height, focal=Math.min(W,H*1.1)*0.95, hy=H*0.36;
const camH=(H*0.82-hy)*CAMBACK/focal;          // le bateau du joueur se pose vers 82 % de la hauteur
return {W,H,focal,hy,camH,camX:A?A.camX:0};
}
function proj(v,x,z){const zc=Math.max(8,z+CAMBACK), k=v.focal/zc;return {x:v.W/2+(x-v.camX)*k, y:v.hy+v.camH*k, k};}
function spawnBoat(P){
const dir=Math.random()<P.oncoming?-1:1, d=A.dist+AHEAD+Math.random()*80;
let x=24+Math.random()*(AR.W-48);
for(let k=0;k<6&&A.boats.some(o=>Math.abs(o.d-d)<70&&Math.abs(o.x-x)<34);k++)x=24+Math.random()*(AR.W-48);
A.boats.push({x,d,dir,v:P.speed*(dir>0?0.32+Math.random()*0.22:0.22+Math.random()*0.3),ph:Math.random()*6,wf:0.6+Math.random(),wa:18+Math.random()*22,
col:ARC_COLS[(Math.random()*ARC_COLS.length)|0],sway:Math.random()<0.5?-1:1});
}
function spawnBand(){
const gust=Math.random()<0.6, w=110+Math.random()*170, x0=Math.random()*(AR.W-w*0.6)-w*0.2;
const d0=A.dist+AHEAD+20; A.bands.push({type:gust?'gust':'calm',d0,d1:d0+90+Math.random()*170,x0,x1:x0+w});
}
function rrect(c,x,y,w,h,r){c.beginPath();c.moveTo(x+r,y);c.lineTo(x+w-r,y);c.quadraticCurveTo(x+w,y,x+w,y+r);c.lineTo(x+w,y+h-r);c.quadraticCurveTo(x+w,y+h,x+w-r,y+h);c.lineTo(x+r,y+h);c.quadraticCurveTo(x,y+h,x,y+h-r);c.lineTo(x,y+r);c.quadraticCurveTo(x,y,x+r,y);c.closePath();}
function sideBoat(c,sx,sy,k,o){
c.save();c.translate(sx,sy);c.rotate(o.heel||0);c.lineJoin='round';c.strokeStyle='#0d1b2a';c.lineWidth=Math.max(1,1.6*k);
c.globalAlpha=o.alpha||1;
c.fillStyle='rgba(5,25,40,.28)';c.beginPath();c.ellipse(0,1.5*k,11*k,2.6*k,0,0,7);c.fill();
const sw=o.sway;
if(o.dir<0){c.beginPath();c.moveTo(0,-6*k);c.lineTo(-sw*1*k,-30*k);c.lineTo(-sw*9*k,-6*k);c.closePath();c.fillStyle=o.sail;c.globalAlpha*=0.9;c.fill();c.stroke();c.globalAlpha=o.alpha||1;}
c.beginPath();c.moveTo(0,-5*k);c.lineTo(0,-44*k);c.quadraticCurveTo(sw*9*k,-22*k,sw*13*k,-6*k);c.closePath();c.fillStyle=o.sail;c.fill();c.stroke();
if(o.label&&LOGO.complete&&LOGO.naturalWidth){c.save();c.beginPath();c.moveTo(0,-5*k);c.lineTo(0,-44*k);c.quadraticCurveTo(sw*9*k,-22*k,sw*13*k,-6*k);c.closePath();c.clip();
const lw=6.2*k, lh=lw*LOGO.naturalHeight/LOGO.naturalWidth, lx=sw>0?0.7*k:-0.7*k-lw; c.drawImage(LOGO,lx,-21*k-lh/2,lw,lh);c.restore();}
c.beginPath();c.moveTo(0,-5*k);c.lineTo(0,-46*k);c.stroke();
c.beginPath();c.moveTo(-10*k,-7*k);c.lineTo(10*k,-7*k);c.lineTo(7.5*k,0);c.lineTo(-7.5*k,0);c.closePath();c.fillStyle='#f7f7f3';c.fill();c.stroke();
c.fillStyle=o.accent;c.fillRect(-9*k,-3.6*k,18*k,2.2*k);
c.beginPath();c.arc(-sw*7.5*k,-9*k,1.7*k,0,7);c.fillStyle=o.accent;c.fill();c.stroke();
if(o.dir>0&&o.player){c.beginPath();c.arc(-sw*3.5*k,-9.5*k,1.7*k,0,7);c.fillStyle=o.accent;c.fill();c.stroke();}
c.restore();
}
function arcDraw(v){
const c=actxA,{W,H,hy}=v; c.setTransform(1,0,0,1,0,0);
const shx=A.shake>0?(Math.random()-0.5)*14:0; c.save(); c.translate(shx,0);
[['#3b86c8',0],['#5a9fd2',0.35],['#8cbfe0',0.62],['#bcdbea',0.82],['#d3e9ef',0.93]].forEach(([col,f])=>{c.fillStyle=col;c.fillRect(0,hy*f,W,hy*(1-f)+1);});
c.fillStyle='#fff6dc';c.beginPath();c.arc(W*0.78-v.camX*0.15,hy*0.3,hy*0.08,0,7);c.fill();
c.fillStyle='rgba(255,255,255,.9)';
for(let i=0;i<5;i++){const cx=((i*W*0.27-v.camX*0.3-A.t*4)%(W*1.3)+W*1.3)%(W*1.3)-W*0.15, cy=hy*(0.18+0.12*(i%3));
c.beginPath();c.ellipse(cx,cy,W*0.07,hy*0.035,0,0,7);c.ellipse(cx+W*0.05,cy-hy*0.02,W*0.05,hy*0.04,0,0,7);c.fill();}
c.fillStyle='#7ea38d';c.strokeStyle='#0d1b2a';c.lineWidth=2;
[[-0.1,0.16,0.05],[0.25,0.12,0.035],[0.62,0.2,0.06],[0.95,0.1,0.03]].forEach(([fx,fw,fh])=>{const x=W*fx-v.camX*0.4;
c.beginPath();c.ellipse(x,hy,W*fw,Math.min(H*fh*0.45,W*fw*0.22),0,Math.PI,0);c.fill();c.stroke();});
c.fillStyle='#0f5778';c.fillRect(0,hy,W,H-hy);
const SEG=60, first=Math.floor((A.dist-CAMBACK+10)/SEG);
for(let n=first+Math.ceil((AHEAD+200)/SEG);n>=first;n--){
const za=n*SEG-A.dist, zb=za+SEG; if(zb<-CAMBACK+8)continue;
const ya=proj(v,0,Math.max(za,-CAMBACK+8)).y, yb=proj(v,0,zb).y;
c.fillStyle=n%2?'#14628a':'#11597e'; c.fillRect(0,yb,W,ya-yb+1);
}
for(const b of A.bands){const z0=Math.max(b.d0-A.dist,-CAMBACK+10), z1=b.d1-A.dist; if(z1<=z0||z0>AHEAD+100)continue;
const p1=proj(v,b.x0-AR.W/2,z0),p2=proj(v,b.x1-AR.W/2,z0),p3=proj(v,b.x1-AR.W/2,z1),p4=proj(v,b.x0-AR.W/2,z1);
c.beginPath();c.moveTo(p1.x,p1.y);c.lineTo(p2.x,p2.y);c.lineTo(p3.x,p3.y);c.lineTo(p4.x,p4.y);c.closePath();
if(b.type==='gust'){c.fillStyle='rgba(4,24,46,.55)';c.fill();}
else{c.fillStyle='rgba(240,248,250,.7)';c.fill();c.strokeStyle='rgba(255,255,255,.95)';c.lineWidth=2;c.stroke();}}
c.strokeStyle='rgba(233,245,248,.5)';
for(let n=first;n<first+Math.ceil(AHEAD/SEG);n++){const z=n*SEG-A.dist+SEG*0.5; if(z<-CAMBACK+12)continue;
for(let j=0;j<4;j++){const x=((n*97+j*131)%(AR.W*2))-AR.W, p=proj(v,x,z); c.lineWidth=Math.min(3,Math.max(1,1.2*p.k));
c.beginPath();c.moveTo(p.x,p.y);c.quadraticCurveTo(p.x+6*p.k,p.y-2.5*p.k,p.x+12*p.k,p.y);c.stroke();}}
const items=[];
const B0=Math.floor(A.dist/150);
for(let n=B0;n<B0+AHEAD/150+2;n++){const z=n*150-A.dist; if(z>-CAMBACK+12)[-14,AR.W+14].forEach(x=>items.push({z,t:'buoy',x:x-AR.W/2}));}
const P=arcLevel(A.lvl), fz=A.lvlStart+P.len-A.dist;
if(fz>-CAMBACK+12&&fz<AHEAD+200)items.push({z:fz,t:'line'});
for(const o of A.boats){const z=o.d-A.dist; if(z>-CAMBACK+12&&z<AHEAD+150)items.push({z,t:'boat',o});}
items.sort((a,b)=>b.z-a.z);
for(const it of items){
if(it.t==='buoy'){const p=proj(v,it.x,it.z);c.fillStyle='#ff6a1a';c.strokeStyle='#0d1b2a';c.lineWidth=Math.max(1,1.2*p.k);
c.beginPath();c.moveTo(p.x-3*p.k,p.y);c.lineTo(p.x,p.y-9*p.k);c.lineTo(p.x+3*p.k,p.y);c.closePath();c.fill();c.stroke();}
else if(it.t==='line'){const a=proj(v,-AR.W/2-14,it.z),b=proj(v,AR.W/2+14,it.z);
c.setLineDash([10,8]);c.strokeStyle='#fff';c.lineWidth=Math.max(2,3*a.k);c.beginPath();c.moveTo(a.x,a.y);c.lineTo(b.x,b.y);c.stroke();c.setLineDash([]);
const top=a.y-60*a.k; c.fillStyle='#0b2540';c.fillRect(a.x,top,b.x-a.x,14*a.k);
c.fillStyle='#ff6a1a';c.fillRect(a.x,top,6*a.k,60*a.k);c.fillRect(b.x-6*a.k,top,6*a.k,60*a.k);
c.fillStyle='#fff';c.font=`800 ${Math.max(10,11*a.k)}px "Big Shoulders Display", Impact, sans-serif`;c.textAlign='center';
c.fillText(A.lvl>=AR.LEVELS?'ARRIVÉE':'FIN DU NIVEAU '+A.lvl,(a.x+b.x)/2,top+11*a.k);}
else{const o=it.o,p=proj(v,o.x-AR.W/2,it.z);sideBoat(c,p.x,p.y,p.k,{dir:o.dir,sway:o.sway*o.dir,sail:o.col,accent:o.col});}
}
const pp=proj(v,A.x-AR.W/2,0);
c.strokeStyle='rgba(255,255,255,.7)';c.lineWidth=2;
for(let i=1;i<6;i++){const q=proj(v,A.x-AR.W/2,-i*12);if(q.y>H)break;c.beginPath();c.moveTo(q.x-i*6*q.k,q.y);c.lineTo(q.x,q.y-2);c.lineTo(q.x+i*6*q.k,q.y);c.stroke();}
if(A.eff==='gust'){c.strokeStyle='rgba(255,255,255,.35)';c.lineWidth=2;for(let i=0;i<8;i++){const x=(i*W/8+A.t*900)%W;c.beginPath();c.moveTo(x,H*0.92);c.lineTo(x+(x-W/2)*0.15,H);c.stroke();}}
sideBoat(c,pp.x,pp.y,pp.k,{dir:1,player:true,sway:A.sway||1,sail:'#fbfbf7',accent:'#ff6a1a',label:true,heel:-A.vx/230*0.22,alpha:A.inv>0&&Math.floor(A.inv*10)%2?0.4:1});
if(A.vx>20)A.sway=-1;else if(A.vx<-20)A.sway=1;
c.restore();
const k=Math.min(devicePixelRatio,2), top=12*k+(matchMedia('(pointer:coarse)').matches?28*k:0), bw=Math.min(W-20*k,330*k);
c.save();c.translate((W-bw)/2,top);
rrect(c,0,0,bw,58*k,10*k);c.fillStyle='rgba(11,37,64,.82)';c.fill();
c.fillStyle='#a9c3d1';c.font=`700 ${10*k}px "Atkinson Hyperlegible", sans-serif`;c.textAlign='left';
c.fillText('NIVEAU',12*k,18*k);c.fillText('POINTS',96*k,18*k);c.fillText('TEMPS',176*k,18*k);
c.fillStyle='#f4f7f6';c.font=`800 ${24*k}px "Big Shoulders Display", Impact, sans-serif`;
c.fillText(A.lvl+'/'+AR.LEVELS,12*k,42*k);c.fillText(String(A.points),96*k,42*k);c.fillText(fmt(A.t),176*k,42*k);
if(bw>280*k){c.textAlign='right';c.fillStyle=A.eff==='gust'?'#3ccf8e':A.eff==='calm'?'#ffc53d':'#a9c3d1';c.font=`700 ${11*k}px "Atkinson Hyperlegible", sans-serif`;
c.fillText(A.eff==='gust'?'RISÉE':A.eff==='calm'?'MOLLE':'',bw-12*k,18*k);c.textAlign='left';}
const prog=Math.min(1,(A.dist-A.lvlStart)/P.len);
c.fillStyle='rgba(255,255,255,.15)';c.fillRect(12*k,50*k,bw-24*k,3*k);c.fillStyle='#ff6a1a';c.fillRect(12*k,50*k,(bw-24*k)*prog,3*k);
c.restore();
}
function arcadeFrame(dt){if(!A)return;const v=arcView();if(state==='arcade')arcStep(dt,v);A.camX+=((A.x-AR.W/2)*0.75-A.camX)*Math.min(1,dt*5);arcDraw(arcView());}
function arcPointerX(e){const v=arcView();return AR.W/2+v.camX+((e.clientX*arc.width/innerWidth)-v.W/2)/(v.focal/CAMBACK);}
arc.addEventListener('pointerdown',e=>{if(!A)return;arc.setPointerCapture(e.pointerId);A.targetX=arcPointerX(e);});
arc.addEventListener('pointermove',e=>{if(!A||!arc.hasPointerCapture(e.pointerId))return;A.targetX=arcPointerX(e);});
['pointerup','pointercancel'].forEach(t=>arc.addEventListener(t,()=>{if(A)A.targetX=null;}));
function stopArcade(){arc.hidden=true;document.body.classList.remove('arcade-on');A=null;musicStop();}
let mus=null;
const MEL=[57,0,60,0,64,0,69,0,67,0,64,0,60,0,62,0, 60,0,65,0,69,0,67,0,65,0,64,0,62,0,60,0, 64,0,67,0,72,0,71,0,67,0,64,0,67,0,69,0, 71,0,67,0,62,0,67,0,71,0,74,0,71,0,67,0].map(n=>n?n+12:0);
const BASS=[45,45,57,45,41,41,53,41,48,48,60,48,43,43,55,43];
const mhz=n=>440*Math.pow(2,(n-69)/12);
function musNote(t,f,dur,type,vol){const o=actx.createOscillator(),g=actx.createGain();o.type=type;o.frequency.value=f;
g.gain.setValueAtTime(vol,t);g.gain.exponentialRampToValueAtTime(0.001,t+dur);o.connect(g);g.connect(mus.out);o.start(t);o.stop(t+dur+0.02);}
function musNoise(t,dur,vol,hp){const s=actx.createBufferSource();s.buffer=noiseBuf;const f=actx.createBiquadFilter();f.type='highpass';f.frequency.value=hp;
const g=actx.createGain();g.gain.setValueAtTime(vol,t);g.gain.exponentialRampToValueAtTime(0.001,t+dur);s.connect(f);f.connect(g);g.connect(mus.out);s.start(t,Math.random(),dur+0.02);}
function musKick(t){const o=actx.createOscillator(),g=actx.createGain();o.frequency.setValueAtTime(140,t);o.frequency.exponentialRampToValueAtTime(40,t+0.12);
g.gain.setValueAtTime(0.5,t);g.gain.exponentialRampToValueAtTime(0.001,t+0.15);o.connect(g);g.connect(mus.out);o.start(t);o.stop(t+0.17);}
function musicStart(){
if(!actx||mus)return;
mus={out:actx.createGain(),step:0,next:actx.currentTime+0.1,bpm:132};mus.out.gain.value=0.18;mus.out.connect(master);
mus.timer=setInterval(()=>{
if(!mus)return; const sp=60/mus.bpm/4;
while(mus.next<actx.currentTime+0.12){
const s=mus.step%64,t=mus.next;
if(MEL[s])musNote(t,mhz(MEL[s]),sp*1.8,'square',0.16);
if(s%2===0)musNote(t,mhz(BASS[(s>>2)%16]),sp*1.6,'triangle',0.5);
if(s%4===0&&(s%16===0||s%16===8))musKick(t);
if(s%8===4)musNoise(t,0.12,0.3,1200);
if(s%2===1)musNoise(t,0.04,0.12,6000);
if(s%16===12&&MEL[s])musNote(t,mhz(MEL[s]+12),sp,'square',0.06);
mus.step++; mus.next+=sp;
}
},25);
}
function musicStop(){if(!mus)return;clearInterval(mus.timer);const o=mus.out;try{o.gain.setTargetAtTime(0,actx.currentTime,0.05);setTimeout(()=>o.disconnect(),300);}catch(e){}mus=null;}
function musicTempo(level){if(mus)mus.bpm=132+level*4;}
function arcadeLoad(){
if(sb){sb.from('arcade_scores').select('user_id,pseudo,points,race_time').order('points',{ascending:true}).order('race_time',{ascending:true}).limit(10).then(r=>{
if(r.error)lbArcadeState='off';else{lbArcade=(r.data||[]).map(d=>({id:d.user_id,pseudo:d.pseudo,points:d.points,time:d.race_time}));lbArcadeState='ok';}
renderArcadeLB();},()=>{lbArcadeState='off';renderArcadeLB();});return;}
if(db&&db.collection){if(arcadeSub)return;arcadeSub=true;
db.collection('lb_arcade').orderBy('score').limit(10).onSnapshot(s=>{
lbArcade=s.docs.map(d=>{const x=d.data();return {id:d.id,pseudo:x.pseudo,points:x.points,time:x.time};});lbArcadeState='ok';renderArcadeLB();
},()=>{lbArcadeState='off';renderArcadeLB();});return;}
if(lbState==='off'){lbArcadeState='off';renderArcadeLB();}
}
function renderArcadeLB(){
const el=$('lbA'); if(!el)return;
if(lbArcadeState==='off'){el.innerHTML='<p class="keys">Classement en ligne momentanément indisponible.</p>';return;}
if(lbArcadeState==='loading'){el.innerHTML='<p class="keys">Chargement du classement…</p>';return;}
if(!lbArcade.length){el.innerHTML='<p class="keys">Aucun score pour l’instant : soyez le premier !</p>';return;}
el.innerHTML='';const box=document.createElement('div');box.className='board';
lbArcade.forEach((d,i)=>{const mine=d.id===uid;
[String(i+1),String(d.pseudo||'Anonyme').slice(0,16),d.points+' pt'+(d.points>1?'s':'')+' · '+fmt(d.time)].forEach(t=>{const s=document.createElement('span');s.textContent=t;if(mine)s.className='me';box.appendChild(s);});});
el.appendChild(box);
}
async function arcadeSave(points,time,pseudo){
const cur={points,time:Math.round(time*100)/100};
if(sb){
let {data}=await sb.auth.getSession(), session=data&&data.session;
if(!session){const r=await sb.auth.signInAnonymously();if(r.error)throw r.error;session=r.data.session;}
uid=session.user.id;
const c=await sb.from('arcade_scores').select('points,race_time').eq('user_id',uid).maybeSingle(); if(c.error)throw c.error;
const prev=c.data?{points:c.data.points,time:c.data.race_time}:null;
if(better(cur,prev)){const u=await sb.from('arcade_scores').upsert({user_id:uid,pseudo,points,race_time:cur.time,updated_at:new Date().toISOString()});
if(u.error)throw u.error; arcadeLoad(); return {prev,saved:true};}
return {prev,saved:false};
}
if(db&&db.doc&&uid){
const ref=db.doc('lb_arcade/'+uid), c=await ref.get(), prev=c.exists?{points:c.data().points,time:c.data().time}:null;
if(better(cur,prev)){await ref.set({pseudo,points,time:cur.time,score:points*100000+cur.time,at:Date.now()});return {prev,saved:true};}
return {prev,saved:false};
}
throw new Error('indisponible');
}
async function endArcade(){
state='done'; musicStop(); horn(0.8);
const points=A.points, time=A.t, pseudo=(loadPseudo()||'Anonyme').slice(0,16);
const top=lbArcadeState==='ok'?lbArcade[0]:null, cur={points,time};
const record=!!top&&better(cur,top)&&!(top.id===uid&&lbArcade.length<2);
let note='', saved=false;
try{const r=await arcadeSave(points,time,pseudo); saved=r.saved;
note=r.saved?(r.prev?`Nouveau record personnel ! (ancien : ${r.prev.points} pt${r.prev.points>1?'s':''} · ${fmt(r.prev.time)})`:'Premier score enregistré au classement.'):`Votre record reste ${r.prev.points} pt${r.prev.points>1?'s':''} · ${fmt(r.prev.time)}.`;
}catch(e){note='Score non enregistré : le classement en ligne ne répond pas.';}
$('card').innerHTML=`<p class="eyebrow">Arcade · slalom · 10 niveaux</p>
<div class="big">${points}<small style="font-size:.45em"> point${points>1?'s':''}</small></div>
<p class="keys">Temps ${fmt(time)} · ${points?`${points} choc${points>1?'s':''}`:'aucun choc, parcours parfait !'}</p>
<p>${note}</p>
${record&&saved?`<p>Record battu (ancien : ${top.points} pt${top.points>1?'s':''} · ${fmt(top.time)}) ! Vous gagnez <b>10 % de réduction</b> sur une commande en ligne Navibreizhshop.</p>${REWARD_WAIT}`
:top?`<p class="keys">Battez le record (${top.points} pt${top.points>1?'s':''} · ${fmt(top.time)}) pour gagner 10 % de réduction sur une commande en ligne.</p>`:''}
<p class="eyebrow" style="margin-top:12px">Meilleurs scores · arcade</p>
<div id="lbA"></div>${shareBlock()}
<button class="cta" id="go" style="margin-top:12px">Rejouer</button>
<button class="ghost" id="menu">Menu</button>`;
renderArcadeLB(); $('overlay').hidden=false;
{const old=lbArcade.find(d=>d.id===uid), mineB=old&&!better(cur,old)?old:{points,time};
const lb=lbArcade.filter(d=>d.id!==uid).concat([{id:uid,pseudo,points:mineB.points,time:mineB.time}]).sort((a,b)=>a.points-b.points||a.time-b.time);
const rows=lb.slice(0,5).map((d,i)=>({rank:i+1,name:d.pseudo||'Anonyme',val:d.points+' pt'+(d.points>1?'s':''),mine:d.id===uid}));
if(!rows.some(r=>r.mine)){const i=lb.findIndex(d=>d.id===uid);rows.push({rank:i+1,name:pseudo,val:mineB.points+' pt'+(mineB.points>1?'s':''),mine:true});}
bindShare(`J’ai terminé les 10 niveaux de l’arcade Régate express de Navibreizhshop avec ${points} point${points>1?'s':''} en ${fmt(time)}${record&&saved?', nouveau record':''} ! À vous de jouer :`,
{eyebrow:'Arcade · slalom · 10 niveaux',big:points+' pt'+(points>1?'s':''),sub:'Temps '+fmt(time)+(record&&saved?' · nouveau record !':''),boardTitle:'Meilleurs scores',rows});}
if(record&&saved)fillReward('arcade',null);
$('go').onclick=()=>{window.goFull&&goFull();startArcade();}; $('menu').onclick=menu;
}
const ICON_D='<svg viewBox="0 0 100 54"><path d="M50 4 L50 44 L80 44 Z" fill="#f4f7f6"/><path d="M48 14 L48 44 L32 44 Z" fill="#a9c3d1"/><path d="M22 46 L82 46 L74 52 L28 52 Z" fill="#ff6a1a"/></svg>';
const ICON_C='<svg viewBox="0 0 100 54"><path d="M50 2 L50 44 L76 44 Z" fill="#f4f7f6"/><path d="M48 10 L48 44 L30 44 Z" fill="#a9c3d1"/><path d="M16 46 L86 46 L80 49 L22 49 Z" fill="#ff6a1a"/><path d="M20 50 L82 50 L78 53 L24 53 Z" fill="#ff6a1a"/></svg>';
function menu(){
state='menu'; series={race:1,results:[]}; mode='champ'; stopArcade(); clearGhosts(); buildFleet(); loadLB();
$('card').innerHTML=`<a class="back" href="/">← Retour à la boutique</a>
<p class="eyebrow">Championnat · Navibreizhshop</p>
<h1>Régate <em>express</em></h1>
<p>Trois modes de jeu. Chacun peut vous faire gagner <b>10 % de réduction</b> sur une commande en ligne.</p>
<div class="picks" role="radiogroup" aria-label="Choix du bateau">
<label class="pick"><input type="radio" name="cls" value="dinghy" ${clsKey==='dinghy'?'checked':''}>${ICON_D}<b>Dériveur</b><span>Vire vite, remonte bien au vent. Idéal pour débuter.</span></label>
<label class="pick"><input type="radio" name="cls" value="cat" ${clsKey==='cat'?'checked':''}>${ICON_C}<b>Catamaran</b><span>Très rapide au travers, mais vire lentement. Au portant, il descend moins que le dériveur.</span></label>
</div>
<label class="keys" for="pseudo">Votre pseudo pour les classements</label>
<input id="pseudo" maxlength="16" autocomplete="nickname" placeholder="ex. Loup de mer">
<button class="cta" id="go">Championnat · 4 courses</button>
<p class="keys" style="margin:10px 0 0">Quatre courses face à cinq concurrents de plus en plus forts, départ avec 30 s de préparation puis 10 s de compte à rebours. Le vainqueur au classement général gagne 10 % de réduction sur une commande en ligne.</p>
<div class="ghostbox">
<button class="cta" id="goGhost">Contre-la-montre · fantômes</button>
<p class="keys" style="margin:10px 0 8px">Face aux trajectoires des meilleurs temps, avec le même vent pour tous et la même procédure de départ (30 s + 10 s). Battez le record de votre bateau pour gagner 10 % de réduction sur une commande en ligne.</p>
<div id="lb" data-both="1"></div>
</div>
<div class="ghostbox">
<button class="cta" id="goArcade">Arcade · slalom</button>
<p class="keys" style="margin:10px 0 8px">Pas de réglages : le bateau avance seul, vous choisissez la direction. Évitez les bateaux que vous doublez et ceux qui arrivent en face. Les bandes sombres (risées) accélèrent, les bandes blanches (molles) ralentissent. Chaque choc coûte 1 point : 10 niveaux de plus en plus rapides et encombrés, terminez avec le moins de points. Battez le record pour gagner 10 % de réduction sur une commande en ligne.</p>
<div id="lbA"></div>
</div>
<div class="ghostbox">
<p class="eyebrow" style="margin:0 0 6px">Bon à savoir</p>
<p class="keys">Parcours (championnat et contre-la-montre) : deux tours, bouées laissées à bâbord, arrivée sur la ligne de départ. Restez sous la ligne jusqu'au signal de départ.</p>
<p class="keys">Plan d'eau : le vent oscille de quelques degrés et forcit dans les risées (zones plus sombres sur l'eau). Un courant traverse le milieu du parcours vers l'est (traînées claires sur l'eau, flèches sur la carte).</p>
<p class="keys">Priorités : bâbord amures s'écarte de tribord amures ; à mêmes amures, le bateau au vent s'écarte du bateau sous le vent, et celui qui rattrape par l'arrière s'écarte. Contact sans priorité ou avec une bouée : +10 s.</p>
<p class="keys">Commandes : boutons ◀ ▶ et glissière d'écoute à l'écran, ou au clavier ← → pour barrer, ↑ border, ↓ choquer, V pour changer de vue. En arcade : ◀ ▶, flèches du clavier, ou glissez le doigt sur l'écran. Pause : bouton ❚❚ PAUSE ou touche P (le jeu se met aussi en pause si vous changez d'onglet).</p>
</div>
<details class="rules">
<summary>Règlement du jeu</summary>
<h3>1. Organisation</h3>
<p>Le jeu « Régate express » est proposé par la boutique Navibreizhshop (voir les <a href="/policies/legal-notice">mentions légales</a>). La participation est gratuite et sans obligation d'achat. Les participants mineurs jouent sous la responsabilité de leurs parents.</p>
<h3>2. Comment gagner</h3>
<p>Championnat : terminer premier au classement général des 4 courses. Contre-la-montre : battre le meilleur temps du classement en ligne pour le bateau choisi. Arcade : battre le meilleur score du classement en ligne (moins de points, puis meilleur temps).</p>
<h3>3. La réduction</h3>
<p>Chaque gagnant reçoit un code de réduction unique de 10 %, affiché à l'écran à la fin de la partie. Ce code :</p>
<ul>
<li>est valable uniquement sur une commande passée sur la boutique en ligne Navibreizhshop (pas en magasin)&nbsp;;</li>
<li>s'applique sur le total de la commande, hors frais de livraison&nbsp;;</li>
<li>n'est utilisable qu'une seule fois, pour une seule commande&nbsp;;</li>
<li>n'est pas cumulable avec une autre réduction, un autre code ou une offre en cours&nbsp;;</li>
<li>n'est ni échangeable, ni remboursable, ni convertible en espèces.</li>
</ul>
<p>Un même joueur peut obtenir au maximum un code par période de 24 heures, tous modes confondus. Pensez à noter ou copier votre code : il n'est pas renvoyé par e-mail.</p>
<h3>4. Équité du jeu</h3>
<p>Tout code obtenu par une manipulation du jeu, de ses données ou des classements peut être annulé, et les scores correspondants supprimés. Navibreizhshop peut modifier, suspendre ou arrêter le jeu, ou réinitialiser les classements, à tout moment.</p>
<h3>5. Données</h3>
<p>Pour les classements, le jeu enregistre uniquement le pseudo choisi, les scores, les trajectoires des parties et un identifiant anonyme. Aucune donnée personnelle n'est demandée pour jouer : choisissez un pseudo qui ne permet pas de vous identifier. Le gagnant qui le souhaite peut s'inscrire à la newsletter Navibreizhshop en indiquant son adresse e-mail et en cochant la case de consentement : l'adresse est alors enregistrée dans le fichier clients de la boutique pour l'envoi d'informations et d'offres. Désinscription possible à tout moment par le lien présent dans chaque e-mail. Cette inscription est facultative et n'a aucune incidence sur la réduction gagnée.</p>
<h3>6. Contact</h3>
<p>Pour toute question : la boutique Navibreizhshop, au ${SHOP_PHONE}.</p>
</details>`;
$('overlay').hidden=false;
$('card').querySelectorAll('input[name=cls]').forEach(r=>r.onchange=()=>{clsKey=r.value;cls=CLASSES[clsKey];buildFleet();renderLB();});
$('go').onclick=()=>{window.goFull&&goFull();mode='champ';start();};
const ps=$('pseudo'); ps.value=loadPseudo(); ps.oninput=()=>savePseudo(ps.value.trim());
ps.addEventListener('keydown',e=>e.stopPropagation());
$('goGhost').onclick=()=>{window.goFull&&goFull();startGhost();}; renderLB();
$('goArcade').onclick=()=>{window.goFull&&goFull();startArcade();}; renderArcadeLB();
}
function start(){
buildFleet(); penalty=0; bumps={}; pairMem={}; lastN=null; camPos.set(me.x,cls.cam[1],me.z+cls.cam[0]);
ensureAudio(); $('overlay').hidden=true; state='count'; count=40.4; horn(0.8);
flash(`Course ${series.race}/${RACES} · 30 s pour vous placer`,2.5);
}
function standings(){
const names=fleet.map(b=>b.name), last=series.results[series.results.length-1]||{};
return names.map(n=>({n,pts:series.results.reduce((s,r)=>s+(r[n]||fleet.length),0),last:last[n]||99,b:fleet.find(b=>b.name===n)}))
.sort((a,b)=>a.pts-b.pts||a.last-b.last);
}
function endRace(){
state='done'; horn(0.7);
const order=fleet.slice().sort((a,b)=>progress(b)-progress(a)), res={};
order.forEach((b,i)=>res[b.name]=i+1); series.results.push(res);
const rank=res[me.name], final=series.race>=RACES, st=standings(), overall=st.findIndex(x=>x.b===me)+1;
const cls_=b=>b===me?'me':'';
const rows=order.map((b,i)=>`<span class="${cls_(b)}">${i+1}</span><span class="${cls_(b)}"><i style="background:${b.css}"></i>${b.name}</span><span class="${cls_(b)}">${b.finish?fmt(b.finish):'en course'}</span>`).join('');
const gen=st.map((x,i)=>`<span class="${cls_(x.b)}">${i+1}</span><span class="${cls_(x.b)}"><i style="background:${x.b.css}"></i>${x.n}</span><span class="${cls_(x.b)}">${x.pts} pt${x.pts>1?'s':''}</span>`).join('');
const sup=n=>n===1?'re':'e';
let html=`<p class="eyebrow">${CLASSES[clsKey].name} · course ${series.race}/${RACES}</p>
<div class="big">${rank}<small style="font-size:.45em">${sup(rank)} place</small></div>
<p class="keys">Temps ${fmt(me.finish)} ${penalty?`· dont ${penalty} s de pénalité`:'· sans pénalité'}</p>
<div class="board">${rows}</div>
<p class="eyebrow" style="margin-top:14px">Classement général${final?' final':''}</p>
<div class="board">${gen}</div>`;
if(!final){
html+=`<p class="keys">Vous êtes ${overall}${sup(overall)} au général. Prochaine course : concurrents plus rapides.</p>
<button class="cta" id="go" style="margin-top:10px">Course suivante (${series.race+1}/${RACES})</button>
<button class="ghost" id="menu">Abandonner le championnat</button>`;
} else if(overall===1){
html+=`<p>Champion ! Vous gagnez <b>10 % de réduction</b> sur une commande en ligne Navibreizhshop.</p>
${REWARD_WAIT}${shareBlock()}
<button class="cta" id="go" style="margin-top:10px">Nouveau championnat</button>`;
} else {
html+=`<p>Vous terminez ${overall}${sup(overall)} du championnat. Seul le vainqueur au général gagne la réduction : retentez votre chance !</p>${shareBlock()}
<button class="cta" id="go" style="margin-top:10px">Nouveau championnat</button>`;
}
$('card').innerHTML=html; $('overlay').hidden=false;
$('go').onclick=final?menu:()=>{series.race++;start();};
const mb=$('menu'); if(mb)mb.onclick=menu;
if(final){const c=CLASSES[clsKey].name.toLowerCase();
bindShare(overall===1?`J’ai remporté le championnat Régate express de Navibreizhshop en ${c} ! Saurez-vous faire mieux ?`
:`J’ai terminé ${overall}${sup(overall)} du championnat Régate express de Navibreizhshop en ${c}. À vous de jouer !`,
{eyebrow:'Championnat · '+CLASSES[clsKey].name+' · 4 courses',big:overall+(overall===1?'re':'e')+' place',sub:overall===1?'Champion !':'Classement général final',
boardTitle:'Classement général',rows:st.map((x,i)=>({rank:i+1,name:x.n,val:x.pts+' pt'+(x.pts>1?'s':''),mine:x.b===me}))});}
if(final&&overall===1)fillReward('champ',clsKey);
}
function resize(){if(typeof arcSize==='function'&&!arc.hidden)arcSize();const w=innerWidth,h=innerHeight;renderer.setSize(w,h,false);camera.aspect=w/h;camera.fov=w<h?78:60;camera.updateProjectionMatrix();spMat.uniforms.scale.value=h*Math.min(devicePixelRatio,2)*0.55;sizeCanvas(mapC);sizeCanvas(vaneC);}
addEventListener('resize',resize); resize();
buildFleet(); fleet.forEach(b=>b.w=windAt(b.x,b.z,0));
menu();
requestAnimationFrame(frame);
})();
